import { JSONValue } from '../types';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: string; output: string; }
  JSON: { input: JSONValue; output: JSONValue; }
  UUID: { input: any; output: any; }
};

export type Absence = {
  comment: Maybe<Scalars['String']['output']>;
  end: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['DateTime']['output'];
  type: AbsenceType;
};

export type AbsenceInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  end: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  start: Scalars['DateTime']['input'];
  type: AbsenceType;
};

export enum AbsenceType {
  Accident = 'accident',
  DeathCloseRelative = 'death_close_relative',
  Marriage = 'marriage',
  Maternity = 'maternity',
  Military = 'military',
  Moving = 'moving',
  Other = 'other',
  Sickness = 'sickness',
  SicknessCloseRelative = 'sickness_close_relative',
  Training = 'training'
}

export type AckActivityLogResult = {
  activityLog: Maybe<ActivityLogItem>;
  hasBeenAcknowledged: Scalars['Boolean']['output'];
};

export type ActivitiesInfo = {
  profileId: Scalars['ID']['output'];
  unreadActivities: Scalars['Int']['output'];
  unreadLogs: Scalars['Int']['output'];
  unreadTodos: Scalars['Int']['output'];
};

export type ActivityLogItem = {
  ack: Scalars['Boolean']['output'];
  activityKey: Maybe<Scalars['String']['output']>;
  activityName: Scalars['String']['output'];
  badgeUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sourceName: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ActivityLogItemPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<ActivityLogItem>;
  pageInfo: PageInfo;
};

export type ActivityTodoItem = {
  activityKey: Maybe<Scalars['String']['output']>;
  activityName: Scalars['String']['output'];
  badgeUrl: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  sourceName: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ActivityType = {
  id: Scalars['ID']['output'];
  ofsSalariumGroupId: Scalars['String']['output'];
  ofsSalariumId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ActivityTypePageResult = {
  count: Scalars['Int']['output'];
  elements: Array<ActivityType>;
  pageInfo: PageInfo;
};

export type Address = {
  formatted: Scalars['String']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  locality: AddressLocality;
  longitude: Maybe<Scalars['Float']['output']>;
  route: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
};

export type AddressCountry = {
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AddressCountryInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddressInput = {
  formatted: Scalars['String']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locality: AddressLocalityInput;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  route: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
};

export type AddressLocality = {
  name: Scalars['String']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  state: AddressState;
};

export type AddressLocalityInput = {
  name: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state: AddressStateInput;
};

export type AddressState = {
  code: Scalars['String']['output'];
  country: AddressCountry;
  name: Scalars['String']['output'];
};

export type AddressStateInput = {
  code: Scalars['String']['input'];
  country: AddressCountryInput;
  name: Scalars['String']['input'];
};

/** Valid date for applying an amendment to the mission */
export type AmendmentPayrollDateResult = {
  date: Scalars['Date']['output'];
  isValid: Scalars['Boolean']['output'];
};

export enum AmendmentSignatureStatus {
  CanceledByLse = 'canceled_by_lse',
  CanceledByOther = 'canceled_by_other',
  CanceledBySelf = 'canceled_by_self',
  Failed = 'failed',
  HandwrittenInProcess = 'handwritten_in_process',
  NeedOtherSign = 'need_other_sign',
  NeedSeal = 'need_seal',
  NeedSelfSign = 'need_self_sign',
  Success = 'success',
  WaitingContract = 'waiting_contract',
  WaitingSelfSign = 'waiting_self_sign'
}

export enum AmendmentSimpleSigningStateType {
  Aborted = 'aborted',
  Draft = 'draft',
  Signed = 'signed',
  WaitingBasquiat = 'waiting_basquiat',
  WaitingClient = 'waiting_client',
  WaitingHandwritten = 'waiting_handwritten',
  WaitingWorker = 'waiting_worker'
}

export enum AmendmentState {
  Accepted = 'accepted',
  Applied = 'applied',
  Canceled = 'canceled',
  Draft = 'draft',
  PendingAcceptation = 'pendingAcceptation',
  Rejected = 'rejected'
}

export type AmendmentValidDatesInput = {
  changedFields: Array<Scalars['String']['input']>;
  monthsAhead?: Scalars['Int']['input'];
};

/** Valid date for applying an amendment to the mission */
export type AmendmentValidDatesResult = {
  /** When true, only dates in valid_dates are allowed */
  hasDateRestriction: Scalars['Boolean']['output'];
  maxDate: Maybe<Scalars['Date']['output']>;
  minDate: Maybe<Scalars['Date']['output']>;
  payrollDates: Maybe<Array<AmendmentPayrollDateResult>>;
};

export type Asset = {
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: AssetStatus;
  url: Maybe<Scalars['String']['output']>;
};

export enum AssetStatus {
  Error = 'error',
  Pending = 'pending',
  Ready = 'ready',
  Timeout = 'timeout'
}

export type AuditLog = {
  createdAt: Scalars['DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  userAvatarUrl: Maybe<Scalars['String']['output']>;
  userDisplayName: Maybe<Scalars['String']['output']>;
};

export type AuditLogPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<AuditLog>;
  pageInfo: PageInfo;
};

export type AuxiliarySalary = {
  baseAmount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  grossAmount: Scalars['Int']['output'];
  invoiceAmount: Scalars['Int']['output'];
};

export type AuxiliarySalaryInput = {
  description: Scalars['String']['input'];
  duration: Scalars['Int']['input'];
  grossAmount: Scalars['Int']['input'];
};

export type BankAccount = {
  beneficiary: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Bank name is not collected anymore */
  name: Scalars['String']['output'];
};

export type BankAccountInput = {
  beneficiary?: InputMaybe<Scalars['String']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  iban: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Bank name is not collected anymore */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type BankDetails = {
  bankName: Scalars['String']['output'];
  bic: Scalars['String']['output'];
};

export type Bonus = {
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  invoiceAmount: Scalars['Int']['output'];
};

export type BonusInput = {
  amount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
};

export type Cct = {
  active: Scalars['Boolean']['output'];
  cctContractId: Scalars['String']['output'];
  cctEditionId: Scalars['String']['output'];
  cctUrl: Maybe<Scalars['String']['output']>;
  cctVersionId: Scalars['String']['output'];
  fees: Array<CctFee>;
  hoursPerWeek: Scalars['Float']['output'];
  hoursPerWeekDefault: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  intercomHelpArticleId: Maybe<Scalars['String']['output']>;
  intercomMainArticleId: Maybe<Scalars['String']['output']>;
  isIjmMandatory: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type CctAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type CctAnswerType = {
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type CctDetailsField = {
  children: Maybe<Array<CctDetailsField>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
  uniqName: Scalars['String']['output'];
  values: Array<CctDetailsFieldValue>;
};

export type CctDetailsFieldFullValue = {
  /** @deprecated use tempdata_call_values instead */
  fullValues: Maybe<Array<CctDetailsFieldValue>>;
  readableValues: Array<CctAnswerType>;
  tempdataCallValues: Array<CctDetailsFieldValue>;
};

export type CctDetailsFieldFullValueInput = {
  fullValues?: InputMaybe<Array<CctDetailsFieldValueInput>>;
  readableValues?: InputMaybe<Array<CctAnswerInput>>;
  tempdataCallValues?: InputMaybe<Array<CctDetailsFieldValueInput>>;
};

export type CctDetailsFieldValue = {
  autoSelected: Maybe<Scalars['Boolean']['output']>;
  criteriaListEntryId: Maybe<Scalars['Int']['output']>;
  criteriaStructureId: Maybe<Scalars['Int']['output']>;
  path: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type CctDetailsFieldValueInput = {
  autoSelected?: InputMaybe<Scalars['Boolean']['input']>;
  criteriaListEntryId?: InputMaybe<Scalars['Int']['input']>;
  criteriaStructureId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CctFee = {
  amount: Maybe<Scalars['Int']['output']>;
  countUnit: Maybe<Scalars['String']['output']>;
  isAvsSalaryExempt: Scalars['Boolean']['output'];
  repetition: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CctPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<Cct>;
  pageInfo: PageInfo;
};

export type CvExperience = {
  professionName: Scalars['String']['output'];
  /** @deprecated Use years_of_experience_decimal field instead */
  yearsOfExperience: Scalars['Int']['output'];
  yearsOfExperienceDecimal: Scalars['Decimal']['output'];
};

export type CvExperienceInput = {
  professionName: Scalars['String']['input'];
  yearsOfExperience: Scalars['Decimal']['input'];
};

export enum CvSource {
  Empty = 'empty',
  Internal = 'internal',
  LinkedinLink = 'linkedin_link',
  PdfDocument = 'pdf_document'
}

export type CvTraining = {
  educationLevel: EducationLevel;
  trainingName: Scalars['String']['output'];
};

export type CvTrainingInput = {
  educationLevel: EducationLevel;
  trainingName: Scalars['String']['input'];
};

export type Client = {
  address: Maybe<Address>;
  bankAccount: Maybe<BankAccount>;
  canChangeIjmConfiguration: Maybe<Scalars['JSON']['output']>;
  /** @deprecated use ijm_configuration instead */
  canChangeIjmGroup: Maybe<Scalars['Boolean']['output']>;
  canChangeLaacConfiguration: Maybe<Scalars['JSON']['output']>;
  canChangeLppConfiguration: Maybe<Scalars['JSON']['output']>;
  /** The client groups in which the caller holds a right: every client group when it holds a role at client level, else the ones it is a member of */
  clientGroups: Array<ClientGroup>;
  contactEmail: Maybe<Scalars['String']['output']>;
  contactPhoneNumber: Maybe<Scalars['String']['output']>;
  contractEffectiveAsset: Maybe<Asset>;
  hoursPerWeekFullTime: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ijmConfiguration: Maybe<Scalars['JSON']['output']>;
  /** @deprecated use ijm_configuration instead */
  ijmGroup: Maybe<IjmGroup>;
  /** @deprecated use ijm_configuration instead */
  ijmPayFirstDays: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use ijm_configuration instead */
  ijmPayRemainingPercents: Maybe<Scalars['Int']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isPrivateClient: Maybe<Scalars['Boolean']['output']>;
  /** The client's LAAC (complementary accident insurance) group per CCT group and worker group: {cctGroups: {<cct>: {<workerGroup|all>: {laacGroup: {id, name} | null}}}}. A null laacGroup is explicitly no LAAC; an absent entry is not configured yet (no LAAC until a contract selects one). */
  laacConfiguration: Maybe<Scalars['JSON']['output']>;
  lang: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  lppConfiguration: Maybe<Scalars['JSON']['output']>;
  name: Maybe<Scalars['String']['output']>;
  rejectedBy: Maybe<RejectedByType>;
  rejectedReason: Maybe<Scalars['String']['output']>;
  signatureStatus: Maybe<ContractSignatureStatus>;
  status: ClientStatus;
  /** Formatted Swiss Enterprise Identification Number */
  uid: Maybe<Scalars['String']['output']>;
  useLegalEmployer: LegalEmployer;
  /** The client carries no IJM: its contracts have no IJM group, and getIjmGroups answers none. */
  withoutIjm: Scalars['Boolean']['output'];
  /** The client carries no LPP: its contracts have no LPP plan, and getLppPlans answers none. */
  withoutLpp: Scalars['Boolean']['output'];
  workerGroups: Array<WorkerGroup>;
};

/** A department, a site or a team of a client. Every mission belongs to one. */
export type ClientGroup = {
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ClientGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** What a client profile holds in one client group. */
export type ClientGroupMembership = {
  clientGroup: ClientGroup;
  permissions: Array<Scalars['String']['output']>;
  role: Maybe<Scalars['String']['output']>;
};

export type ClientGroupRoleInput = {
  clientGroupId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
};

export type ClientInfo = {
  address: Maybe<Address>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  canSignContracts: Scalars['Boolean']['output'];
  contactEmail: Maybe<Scalars['String']['output']>;
  contactPhoneNumber: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  email: Maybe<Scalars['String']['output']>;
  hoursPerWeekFullTime: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isPrivateClient: Maybe<Scalars['Boolean']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  profileName: Scalars['String']['output'];
  signatureCapacity: SignatureCapacity;
  signatureFunction: Maybe<Scalars['String']['output']>;
  status: ClientStatus;
  uid: Maybe<Scalars['String']['output']>;
  useLse: Scalars['Boolean']['output'];
  verified: Scalars['Boolean']['output'];
};

export type ClientInfoPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<ClientInfo>;
  pageInfo: PageInfo;
};

export type ClientInput = {
  address?: InputMaybe<AddressInput>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  hoursPerWeekFullTime?: InputMaybe<Scalars['Float']['input']>;
  ijmGroupId?: InputMaybe<Scalars['String']['input']>;
  ijmPayFirstDays?: InputMaybe<Scalars['Boolean']['input']>;
  ijmPayRemainingPercents?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type ClientProfile = {
  businessEmail: Maybe<Scalars['String']['output']>;
  businessEmailVerified: Maybe<Scalars['Boolean']['output']>;
  canInviteWorker: Scalars['Boolean']['output'];
  canSignContracts: Scalars['Boolean']['output'];
  client: Client;
  /** The client groups in which the profile holds a right, with its effective permissions in each: every client group when it holds a role at client level, else the ones it is a member of */
  clientGroups: Array<ClientGroupMembership>;
  /** Effective permission codes held at client level, in every client group */
  clientPermissions: Array<Scalars['String']['output']>;
  clientRelationshipCount: Scalars['Int']['output'];
  /** @deprecated Not used anymore */
  contractEffectiveAsset: Maybe<Asset>;
  /** @deprecated Not used anymore */
  contractSealedAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Not used anymore */
  contractSignedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isPrivateClient: Maybe<Scalars['Boolean']['output']>;
  role: Maybe<Scalars['String']['output']>;
  signatureCapacity: SignatureCapacity;
  signatureFunction: Maybe<Scalars['String']['output']>;
};

export type ClientProfileInput = {
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  canSignContracts?: InputMaybe<Scalars['Boolean']['input']>;
  client?: InputMaybe<ClientInput>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserInput>;
};

/** A role a client assigns to its client profiles. Lift defines the roles. */
export type ClientRole = {
  allowedOn: Array<RoleLevel>;
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export enum ClientStatus {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected',
  Signed = 'signed'
}

export type ClientUser = {
  avatarUrl: Maybe<Scalars['String']['output']>;
  canSignContracts: Scalars['Boolean']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  joinedAt: Scalars['DateTime']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  signatureCapacity: SignatureCapacity;
  signatureFunction: Maybe<Scalars['String']['output']>;
};

export type Contract = {
  baseSalary: Maybe<Scalars['Int']['output']>;
  cctContractId: Maybe<Scalars['String']['output']>;
  cctDetails: Maybe<CctDetailsFieldFullValue>;
  cctEditionId: Maybe<Scalars['String']['output']>;
  clientAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  clientContractSealedAt: Maybe<Scalars['DateTime']['output']>;
  clientContractSignedAt: Maybe<Scalars['DateTime']['output']>;
  clientDeductions: Maybe<Array<SalaryDeductionType>>;
  contractEffectiveAsset: Maybe<Asset>;
  createdAt: Scalars['DateTime']['output'];
  dailyHours: Maybe<Scalars['Float']['output']>;
  deductions: Maybe<Array<MissionDeduction>>;
  /** What payroll holds back each period and pays out later, in cents: the 13th month on a 13x contract, the vacation indemnity on a cagnotte contract, or 0. Always 0 under an LSE legal employer. net_salary already excludes it, so gross = net + worker contributions + this. */
  deferredIndemnity: Scalars['Int']['output'];
  disableAvsSmallSalaryExemption: Scalars['Boolean']['output'];
  earningType: EarningType;
  effectiveEndDate: Maybe<Scalars['Date']['output']>;
  endDate: Maybe<Scalars['Date']['output']>;
  fees: Maybe<Array<MissionFee>>;
  /** LPP applies even below the plan's entry threshold. On an on-demand contract (workingTimeClassicSpec.repetition = on_demand) it is the LPP choice itself. */
  forceLpp: Scalars['Boolean']['output'];
  grossSalary: Maybe<Scalars['Int']['output']>;
  has13thSalary: Maybe<Scalars['Boolean']['output']>;
  hoursPerWeekFullTime: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ijmInfo: Maybe<IjmInfo>;
  invoiceSalary: Maybe<Scalars['Int']['output']>;
  jobDescription: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  /** The LAAC (complementary accident insurance) group this contract carries; null: none. */
  laacGroup: Maybe<LaacGroup>;
  /** The LPP fund sets each worker's amount, LPP is due and Lift has not entered it yet: the deductions carry no LPP until it does. Show that the LPP amount is still to be defined by the fund. */
  lppAmountToBeDefined: Scalars['Boolean']['output'];
  /** The employer's monthly LPP in cents when the LPP fund sets each worker's amount, entered by Lift. Null until then, and for a plan with rates. */
  lppEmployerMonthlyAmount: Maybe<Scalars['Int']['output']>;
  lppPlan: Maybe<LppPlan>;
  /** The worker's monthly LPP in cents when the LPP fund sets each worker's amount (lppPlan.fund.amountDefinedByFund), entered by Lift. Null until then, and for a plan with rates. */
  lppWorkerMonthlyAmount: Maybe<Scalars['Int']['output']>;
  lseMargin: Maybe<Scalars['Int']['output']>;
  missionInfo: Maybe<MissionInfo>;
  netSalary: Maybe<Scalars['Int']['output']>;
  pay13thSalaryWithSalary: Scalars['Boolean']['output'];
  payVacationIndemnityWithSalary: Scalars['Boolean']['output'];
  publicHolidaysCompensation: Maybe<Scalars['Int']['output']>;
  publicHolidaysCompensationRate: Maybe<Scalars['Decimal']['output']>;
  signatureStatus: ContractSignatureStatus;
  /** When a batch signature was queued for the awaited signer, while it is still in flight. Non-null means the signature is already on its way — do not offer this contract in the sign list. Queued is not signed: `signatureStatus` keeps its current value until the signature completes. Returns to null by itself if the queued signature never completes, so the contract reappears in the list and can simply be signed again. */
  signingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated use signature_status instead */
  signingState: SimpleSigningState;
  startDate: Maybe<Scalars['Date']['output']>;
  state: ContractState;
  terminatedBy: Maybe<TerminatedByType>;
  terminatedDate: Maybe<Scalars['Date']['output']>;
  terminationOtherReason: Maybe<Scalars['String']['output']>;
  terminationOwner: Maybe<UserInfo>;
  terminationReason: Maybe<TerminateReason>;
  thirteenMonthCompensation: Maybe<Scalars['Int']['output']>;
  thirteenMonthCompensationRate: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated no more used */
  useClientWorkingAddress: Maybe<Scalars['Boolean']['output']>;
  vacationCompensation: Maybe<Scalars['Int']['output']>;
  vacationCompensationRate: Maybe<Scalars['Decimal']['output']>;
  vacationDays: Maybe<Scalars['Int']['output']>;
  workerAcceptedAt: Maybe<Scalars['DateTime']['output']>;
  workerContractSealedAt: Maybe<Scalars['DateTime']['output']>;
  workerContractSignedAt: Maybe<Scalars['DateTime']['output']>;
  workerDeductions: Maybe<Array<SalaryDeductionType>>;
  workingAddress: Maybe<Address>;
  workingPercentage: Maybe<Scalars['Int']['output']>;
  /** @deprecated no more used */
  workingTime: Maybe<WorkingTime>;
  workingTimeClassicSpec: Maybe<WorkingTimeClassicType>;
  /** @deprecated no more used */
  workingTimeScheduleSpec: Maybe<WorkingTimeScheduleType>;
  /** @deprecated no more used */
  workingTimeSpecificSpec: Maybe<WorkingTimeSpecificType>;
};

export type ContractInput = {
  baseSalary?: InputMaybe<Scalars['Int']['input']>;
  cctDetails?: InputMaybe<CctDetailsFieldFullValueInput>;
  cctEditionId?: InputMaybe<Scalars['String']['input']>;
  dailyHours?: InputMaybe<Scalars['Float']['input']>;
  deductions?: InputMaybe<Array<MissionDeductionInput>>;
  /** Force-off override for the AVS small-salary exemption. On an on-demand contract it is the AVS decision itself (true = AVS applies, false = exempted), required when the contract is priced. */
  disableAvsSmallSalaryExemption?: InputMaybe<Scalars['Boolean']['input']>;
  earningType?: InputMaybe<EarningType>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  fees?: InputMaybe<Array<MissionFeeInput>>;
  /** LPP applies even below the plan's entry threshold; refused under an LSE legal employer. On an on-demand contract it is the LPP choice itself (true = LPP, false = no LPP unless the plan has no entry threshold), required when the contract is priced, and refused with disableAvsSmallSalaryExemption false (LPP requires AVS). */
  forceLpp?: InputMaybe<Scalars['Boolean']['input']>;
  grossSalary?: InputMaybe<Scalars['Int']['input']>;
  has13thSalary?: InputMaybe<Scalars['Boolean']['input']>;
  hoursPerWeekFullTime?: InputMaybe<Scalars['Float']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lppPlanId?: InputMaybe<Scalars['String']['input']>;
  pay13thSalaryWithSalary?: InputMaybe<Scalars['Boolean']['input']>;
  payVacationIndemnityWithSalary?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Not used anymore */
  useClientWorkingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  vacationDays?: InputMaybe<Scalars['Int']['input']>;
  workingAddress?: InputMaybe<AddressInput>;
  workingTime?: InputMaybe<WorkingTime>;
  workingTimeClassicSpec?: InputMaybe<WorkingTimeClassicInput>;
};

export enum ContractSignatureStatus {
  /** Signature process canceled by LSE */
  CanceledByLse = 'canceled_by_lse',
  /** Signature process canceled by other party */
  CanceledByOther = 'canceled_by_other',
  /** Signature process canceled by you */
  CanceledBySelf = 'canceled_by_self',
  /** Something went wrong during the signing process */
  Failed = 'failed',
  /** The contract is signed on paper: it is printed, signed by hand by every party and scanned back by Lift. Nobody signs in the app and there is no action to take here. */
  HandwrittenInProcess = 'handwritten_in_process',
  /** The other party need to sign the contract */
  NeedOtherSign = 'need_other_sign',
  /** Contract need to be signed by LSE */
  NeedSeal = 'need_seal',
  /** The contract is ready to be signed by the user querying this query */
  NeedSelfSign = 'need_self_sign',
  /** All parties signed the contract */
  Success = 'success',
  /** the contract need to wait for its contract asset nd/or framework asset to become ready */
  WaitingContract = 'waiting_contract',
  /** Contract is waiting for signature processing by the user querying this query */
  WaitingSelfSign = 'waiting_self_sign'
}

/** The result of the contract global signing status, involving all parties; client, worker and the LSE */
export type ContractSignatureStatusResult = {
  /** The current status of the contract signing process */
  status: ContractSignatureStatus;
};

/** The result of the contract global signing status, involving all parties; client, worker and the LSE */
export type ContractSigning = {
  /** The current status of the contract signing process */
  status: ContractSigningStatus;
};

export enum ContractSigningStatus {
  /** Signature process canceled by LSE */
  CanceledByLse = 'canceled_by_lse',
  /** Signature process canceled by other party */
  CanceledByOther = 'canceled_by_other',
  /** Signature process canceled by you */
  CanceledBySelf = 'canceled_by_self',
  /** Something went wrong during the signing process */
  Failed = 'failed',
  /** The contract is signed on paper: printed, signed by hand by every party and scanned back by Lift. Nobody signs in the app and there is no action to take here. */
  HandwrittenInProcess = 'handwritten_in_process',
  /** The other party need to sign the contract */
  NeedOtherSign = 'need_other_sign',
  /** Contract need to be signed by LSE */
  NeedSeal = 'need_seal',
  /** The contract is ready to be signed by the user querying this query */
  NeedSelfSign = 'need_self_sign',
  /** All parties signed the contract */
  Success = 'success',
  /** the contract need to wait for its contract asset nd/or framework asset to become ready */
  WaitingContract = 'waiting_contract',
  /** Contract is waiting for signature completion (identification + signature) */
  WaitingSelfSign = 'waiting_self_sign'
}

export enum ContractState {
  Accepted = 'accepted',
  Cancelled = 'cancelled',
  Draft = 'draft',
  Ended = 'ended',
  PendingAcceptation = 'pendingAcceptation',
  Terminated = 'terminated'
}

export type CreateAmendmentInput = {
  applyDate: Scalars['Date']['input'];
  /** The whole new deduction list: an existing deduction keeps its id */
  deductions?: InputMaybe<Array<MissionDeductionInput>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The whole new fee list: an existing fee keeps its id */
  fees?: InputMaybe<Array<MissionFeeInput>>;
  grossSalary?: InputMaybe<Scalars['Int']['input']>;
  missionId: Scalars['ID']['input'];
  /** Makes the change temporary: the previous terms come back the day after */
  untilDate?: InputMaybe<Scalars['Date']['input']>;
  vacationDays?: InputMaybe<Scalars['Int']['input']>;
  workingTimeClassicSpec?: InputMaybe<WorkingTimeClassicInput>;
};

export type CurriculumVitae = {
  experiences: Maybe<Array<CvExperience>>;
  link: Maybe<Scalars['String']['output']>;
  pdfDocumentUrl: Maybe<Scalars['String']['output']>;
  source: CvSource;
  trainings: Maybe<Array<CvTraining>>;
};

export type CurriculumVitaeInput = {
  experiences?: InputMaybe<Array<CvExperienceInput>>;
  link?: InputMaybe<Scalars['String']['input']>;
  pdfDocumentUrl?: InputMaybe<Scalars['String']['input']>;
  source: CvSource;
  trainings?: InputMaybe<Array<CvTrainingInput>>;
};

export type DateScheduleInput = {
  date: Scalars['Date']['input'];
  daySchedule?: InputMaybe<DayScheduleInput>;
};

export type DateScheduleType = {
  date: Scalars['Date']['output'];
  daySchedule: Maybe<DayScheduleType>;
  /** @deprecated replaced by day_schedule */
  times: Maybe<Array<ScheduleType>>;
};

export type DayScheduleInput = {
  fixedTimes?: InputMaybe<Array<ScheduleInput>>;
  freeDurations?: InputMaybe<Array<DurationInput>>;
  timeMode?: TimeMode;
};

export type DayScheduleType = {
  fixedTimes: Maybe<Array<ScheduleType>>;
  /** @deprecated replaced by free_durations */
  freeDuration: Maybe<Scalars['Int']['output']>;
  freeDurations: Maybe<Array<DurationType>>;
  timeMode: TimeMode;
};

export type DemoDocument = {
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DemoDocumentChanges = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DemoDocumentPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<DemoDocument>;
  pageInfo: PageInfo;
};

export type Document = {
  asset: Maybe<Asset>;
  documentUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inlineContent: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: DocumentType;
};

export enum DocumentBasketStatus {
  Corrupted = 'CORRUPTED',
  Deleted = 'DELETED',
  DeletedTemporary = 'DELETED_TEMPORARY',
  Downloaded = 'DOWNLOADED',
  Failed = 'FAILED',
  Outstanding = 'OUTSTANDING',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Signed = 'SIGNED',
  SignedPartially = 'SIGNED_PARTIALLY'
}

export type DocumentInput = {
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inlineContent?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: DocumentType;
};

export enum DocumentType {
  CompanyPicture = 'companyPicture',
  CompanyPolicy = 'companyPolicy',
  CurriculumVitae = 'curriculumVitae',
  Experience = 'experience',
  FiscalAttestation = 'fiscalAttestation',
  KycDocument = 'kycDocument',
  MissionAnnex = 'missionAnnex',
  Other = 'other',
  ProfilePicture = 'profilePicture',
  WorkPermit = 'workPermit'
}

export type DurationInput = {
  duration: Scalars['Int']['input'];
  type?: ScheduleTimeType;
};

export type DurationType = {
  duration: Scalars['Int']['output'];
  type: ScheduleTimeType;
};

export type DynamicDeduction = {
  count: Maybe<Scalars['Float']['output']>;
  deduction: MissionDeduction;
};

export type DynamicDeductionInput = {
  count: Scalars['Float']['input'];
  refId: Scalars['String']['input'];
};

export type DynamicFee = {
  count: Maybe<Scalars['Float']['output']>;
  fee: MissionFee;
};

export type DynamicFeeInput = {
  count: Scalars['Float']['input'];
  refId: Scalars['String']['input'];
};

export enum EarningType {
  Daily = 'daily',
  Hourly = 'hourly',
  Monthly = 'monthly',
  Package = 'package'
}

export enum EducationLevel {
  Baccalaureate = 'baccalaureate',
  Cfc = 'cfc',
  HesHep = 'hes_hep',
  HighSchool = 'high_school',
  InCompany = 'in_company',
  TeachingCertificate = 'teaching_certificate',
  UniEpf = 'uni_epf',
  Without = 'without'
}

export type EffectiveFee = {
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type EffectiveFeeInput = {
  amount: Scalars['Int']['input'];
  description: Scalars['String']['input'];
};

export enum FeeCountUnit {
  Default = 'default',
  Km = 'km'
}

export enum FeeType {
  Cct = 'cct',
  Food = 'food',
  Other = 'other',
  Phone = 'phone',
  PrivateTransport = 'private_transport',
  PublicTransport = 'public_transport',
  RemoteWork = 'remote_work'
}

export enum Gender {
  Female = 'female',
  Male = 'male',
  Unknown = 'unknown'
}

/** Id of amendment's new assets */
export type GenerateAmendmentAssetResult = {
  clientAssetId: Scalars['ID']['output'];
  workerAssetId: Scalars['ID']['output'];
};

/** Id of contract's new assets */
export type GenerateContractAssetResult = {
  clientAssetId: Scalars['ID']['output'];
  workerAssetId: Scalars['ID']['output'];
};

export type IjmChoice = {
  benefitPeriodDays: Scalars['Int']['output'];
  clientRate: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  clientRateFemale: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  clientRateMale: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  name: Scalars['String']['output'];
  waitingPeriodDays: Scalars['Int']['output'];
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  workerRate: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  workerRateFemale: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated IJMChoice will be replaced by IJMGroup */
  workerRateMale: Maybe<Scalars['Decimal']['output']>;
};

export type IjmSelectionInput = {
  ijmGroupId?: InputMaybe<Scalars['String']['input']>;
  ijmPayFirstDays?: InputMaybe<Scalars['Boolean']['input']>;
  ijmPayRemainingPercents?: InputMaybe<Scalars['Int']['input']>;
};

export type IdentificationStatus = {
  reason: Maybe<Scalars['String']['output']>;
  reasonCode: Maybe<Scalars['Int']['output']>;
  status: KycStatus;
  veriffUrl: Scalars['String']['output'];
};

export type IjmGroup = {
  benefitPeriodDays: Scalars['Int']['output'];
  clientRate: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated was not used and will be removed in future */
  contractId: Maybe<Scalars['String']['output']>;
  contractName: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated was not used and will be removed in future */
  maxAnnualSalary: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  waitingPeriodDays: Scalars['Int']['output'];
  /** @deprecated was not used and will be removed in future */
  workerRate: Maybe<Scalars['Decimal']['output']>;
};

export type IjmInfo = {
  ijmGroup: Maybe<IjmGroup>;
  payFirstDays: Scalars['Boolean']['output'];
  payRemainingPercents: Scalars['Int']['output'];
};

export type Invitation = {
  clientFormattedAddress: Maybe<Scalars['String']['output']>;
  /** Worker invitation: the client groups the worker is linked to on acceptance, among those where the caller's client profile holds `worker.view`. */
  clientGroupIds: Array<Scalars['ID']['output']>;
  /** Member invitation: the role the member gets in each client group named. */
  clientGroupRoles: Array<InvitationClientGroupRole>;
  clientLogoUrl: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  clientRole: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  mode: Maybe<InvitationMode>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  senderName: Scalars['String']['output'];
  target: Maybe<InvitationTarget>;
  text: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type InvitationClientGroupRole = {
  clientGroupId: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

export type InvitationCodeError = {
  message: Scalars['String']['output'];
  messageKey: Scalars['String']['output'];
};

export type InvitationCodeResponse = InvitationCodeError | InvitationCodeSuccess;

export type InvitationCodeSuccess = {
  invitation: Invitation;
};

export enum InvitationMode {
  Receiver = 'receiver',
  Sender = 'sender'
}

export type InvitationPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<Invitation>;
  pageInfo: PageInfo;
};

export enum InvitationTarget {
  Client = 'client',
  Worker = 'worker'
}

export type Invoice = {
  fromDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoiceAsset: Maybe<Asset>;
  invoiceNumber: Scalars['String']['output'];
  invoiceType: InvoiceType;
  /** @deprecated Use mission_invoices instead */
  missionInfo: MissionInfo;
  missionInvoices: Array<MissionInvoice>;
  paidAt: Maybe<Scalars['DateTime']['output']>;
  sentAt: Maybe<Scalars['DateTime']['output']>;
  toDate: Scalars['Date']['output'];
  totalAmount: Scalars['Int']['output'];
};

export type InvoicePageResult = {
  count: Scalars['Int']['output'];
  elements: Array<Invoice>;
  pageInfo: PageInfo;
};

export enum InvoiceType {
  Correction = 'correction',
  DownPayment = 'down_payment',
  FinalSettlement = 'final_settlement'
}

export enum KycStatus {
  Accepted = 'accepted',
  Banned = 'banned',
  Init = 'init',
  Pending = 'pending',
  Rejected = 'rejected',
  Submitted = 'submitted'
}

/** Complementary accident insurance (LAAC) selection. laacGroupId null: no LAAC. Stored in the client's LAAC configuration for the CCT and worker group, and refused once contracts lock a different one. */
export type LaacSelectionInput = {
  laacGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type LppFund = {
  amountDefinedByFund: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  needRegistration: Scalars['Boolean']['output'];
};

export type LppPlan = {
  assetUrl: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** @deprecated Should not be used anymore. */
  fromYearlySalary: Scalars['Int']['output'];
  fund: LppFund;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export type LppRegistration = {
  fund: LppFund;
  registrationFormData: Maybe<Scalars['JSON']['output']>;
};

export enum LaaActivityType {
  Office = 'office',
  Technical = 'technical'
}

/** One insured salary band of a LAAC group: its rates are charged on the part of the annual salary between minAnnualSalary and maxAnnualSalary (CHF cents). */
export type LaacBand = {
  femaleRate: LaacRate;
  maleRate: LaacRate;
  maxAnnualSalary: Scalars['Int']['output'];
  minAnnualSalary: Scalars['Int']['output'];
};

/** A complementary accident insurance (LAAC) group. Bands and rates are those in force today: the salary is charged band by band, each part at its band's rates. */
export type LaacGroup = {
  /** True: a worker working fewer than 8 hours a week is not covered. */
  appliesFrom8HoursPerWeek: Scalars['Boolean']['output'];
  /** The insured salary bands in force today, by increasing salary; empty without one. */
  bands: Array<LaacBand>;
  contractName: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  /** @deprecated Describes the first salary band only: read bands, which lists them all. */
  femaleRate: Maybe<LaacRate>;
  id: Scalars['ID']['output'];
  /** @deprecated Describes the first salary band only: read bands, which lists them all. */
  maleRate: Maybe<LaacRate>;
  /**
   * Top of the insured salary band, annual, in CHF cents.
   * @deprecated Describes the first salary band only: read bands, which lists them all.
   */
  maxAnnualSalary: Maybe<Scalars['Int']['output']>;
  /**
   * Bottom of the insured salary band, annual, in CHF cents.
   * @deprecated Describes the first salary band only: read bands, which lists them all.
   */
  minAnnualSalary: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type LaacRate = {
  client: Scalars['Decimal']['output'];
  worker: Scalars['Decimal']['output'];
};

export type LegalEmployer = {
  id: Scalars['ID']['output'];
  marketingName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  useLseCct: Scalars['Boolean']['output'];
};

export enum MaritalStatus {
  Divorced = 'divorced',
  Married = 'married',
  RegisteredPartnership = 'registered_partnership',
  Separated = 'separated',
  Single = 'single',
  Widowed = 'widowed'
}

export enum MesoneerUbiIdStatus {
  Corrupted = 'CORRUPTED',
  Deleted = 'DELETED',
  DeletedMarked = 'DELETED_MARKED',
  DeletedTemporary = 'DELETED_TEMPORARY',
  Downloaded = 'DOWNLOADED',
  DownloadFailed = 'DOWNLOAD_FAILED',
  IdentificationFailed = 'IDENTIFICATION_FAILED',
  IdentificationNotRequired = 'IDENTIFICATION_NOT_REQUIRED',
  IdentificationSuccessful = 'IDENTIFICATION_SUCCESSFUL',
  Initialized = 'INITIALIZED',
  Scheduled = 'SCHEDULED',
  Timeout = 'TIMEOUT',
  VerificationConfirmed = 'VERIFICATION_CONFIRMED',
  VerificationPending = 'VERIFICATION_PENDING',
  VerificationRejected = 'VERIFICATION_REJECTED'
}

export type Mission = {
  activityType: Maybe<ActivityType>;
  amendmentSigningState: Maybe<AmendmentSimpleSigningStateType>;
  /** The client group the mission belongs to. It changes through moveMission only */
  clientGroup: Maybe<ClientGroup>;
  clientInfo: ClientInfo;
  compensateOvertime: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentContract: Maybe<Contract>;
  documents: Array<Document>;
  educationLevel: Maybe<EducationLevel>;
  /** When the engagement actually ends: the effective end date of the latest version that binds the parties (accepted/ended/terminated), early termination included. A draft, a renewal awaiting signature and a cancelled version do not end it. Null for an open-ended contract, and while nothing is signed yet */
  effectiveEndDate: Maybe<Scalars['Date']['output']>;
  /** Planned end date of the contract's newest version, whatever its state -- the version being prepared (a draft, or a renewal awaiting signature) included. Null for an open-ended contract. Use effectiveEndDate for when the engagement actually ends */
  endDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** URL of the PDF of the contract the mission started with. Applying an amendment creates a new contract carrying the amendment document as its signed asset, so `currentContract` stops giving access to it. The initial contract is the current one until that happens, so without any applied amendment this serves the same document as `currentContract`. Null when the mission has no dated contract, or while its document is not ready yet. */
  initialContractPdf: Maybe<Scalars['String']['output']>;
  laaActivityType: Maybe<LaaActivityType>;
  laaGroupId: Maybe<Scalars['String']['output']>;
  legalEmployer: LegalEmployer;
  name: Maybe<Scalars['String']['output']>;
  /** @deprecated will be removed. Return always None from now */
  onboarding: Maybe<MissionOnboarding>;
  payrollSource: Maybe<PayrollSourceType>;
  signerInfo: Maybe<ClientInfo>;
  /** Start date of the oldest contract of the mission, regardless of its state */
  startDate: Maybe<Scalars['Date']['output']>;
  terminationInfo: Maybe<TerminationInfo>;
  updatedAt: Scalars['DateTime']['output'];
  workerGroup: Maybe<WorkerGroup>;
  workerInfo: WorkerInfo;
};

export type MissionAmendment = {
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  amendmentEffectiveAsset: Maybe<Asset>;
  applyDate: Scalars['Date']['output'];
  canceledAt: Maybe<Scalars['DateTime']['output']>;
  canceledReason: Maybe<Scalars['String']['output']>;
  changes: Array<MissionAmendmentChange>;
  clientAmendmentSealedAt: Maybe<Scalars['DateTime']['output']>;
  clientAmendmentSignedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  missionId: Scalars['ID']['output'];
  missionInfo: Maybe<MissionInfo>;
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  rejectedReason: Maybe<Scalars['String']['output']>;
  /** Set on a revert: the temporary amendment whose terms it restores */
  revertsAmendmentId: Maybe<Scalars['ID']['output']>;
  signatureModel: Maybe<Scalars['String']['output']>;
  signatureStatus: AmendmentSignatureStatus;
  signingState: Maybe<AmendmentSimpleSigningStateType>;
  state: AmendmentState;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  /** Set on a temporary change: its terms hold until this date, then its revert restores the previous ones */
  untilDate: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  workerAmendmentSealedAt: Maybe<Scalars['DateTime']['output']>;
  workerAmendmentSignedAt: Maybe<Scalars['DateTime']['output']>;
};

export type MissionAmendmentChange = {
  field: Scalars['String']['output'];
  newValue: Maybe<Scalars['String']['output']>;
  oldValue: Maybe<Scalars['String']['output']>;
};

export type MissionCancellationRequest = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isCancelledBySelf: Scalars['Boolean']['output'];
  otherReason: Maybe<Scalars['String']['output']>;
  reason: TerminateReason;
  requestedRole: TerminatedByType;
  terminationDate: Maybe<Scalars['Date']['output']>;
};

export type MissionCount = {
  accepted: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  ended: Scalars['Int']['output'];
  pendingAcceptation: Scalars['Int']['output'];
  terminated: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MissionDeduction = {
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  repetition: RepetitionType;
};

export type MissionDeductionInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  repetition?: InputMaybe<RepetitionType>;
};

export type MissionFee = {
  amount: Scalars['Int']['output'];
  countUnit: Maybe<FeeCountUnit>;
  externalId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceAmount: Scalars['Int']['output'];
  isAvsSalaryExempt: Scalars['Boolean']['output'];
  otherTitle: Maybe<Scalars['String']['output']>;
  repetition: RepetitionType;
  type: FeeType;
};

export type MissionFeeInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  countUnit?: InputMaybe<FeeCountUnit>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceAmount?: InputMaybe<Scalars['Int']['input']>;
  isAvsSalaryExempt?: InputMaybe<Scalars['Boolean']['input']>;
  otherTitle?: InputMaybe<Scalars['String']['input']>;
  repetition?: InputMaybe<RepetitionType>;
  type?: InputMaybe<FeeType>;
};

export type MissionInfo = {
  activityType: Maybe<ActivityType>;
  clientInfo: Maybe<ClientInfo>;
  compensateOvertime: Maybe<Scalars['Boolean']['output']>;
  earningType: Maybe<EarningType>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  payrollSource: Maybe<PayrollSourceType>;
  signerInfo: Maybe<ClientInfo>;
  workerInfo: Maybe<WorkerInfo>;
  workingTime: Maybe<WorkingTime>;
  workingTimeClassicSpec: Maybe<WorkingTimeClassicType>;
};

export type MissionInput = {
  activityTypeId?: InputMaybe<Scalars['ID']['input']>;
  clientGroupId?: InputMaybe<Scalars['ID']['input']>;
  clientProfileId?: InputMaybe<Scalars['ID']['input']>;
  compensateOvertime?: InputMaybe<Scalars['Boolean']['input']>;
  contract?: InputMaybe<ContractInput>;
  documents?: InputMaybe<Array<DocumentInput>>;
  educationLevel?: InputMaybe<EducationLevel>;
  ijmSelection?: InputMaybe<IjmSelectionInput>;
  laaActivityType?: InputMaybe<LaaActivityType>;
  laaGroupId?: InputMaybe<Scalars['String']['input']>;
  laacSelection?: InputMaybe<LaacSelectionInput>;
  lang?: InputMaybe<Scalars['String']['input']>;
  legalEmployerId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payrollSource?: InputMaybe<PayrollSourceType>;
  workerGroupId?: InputMaybe<Scalars['ID']['input']>;
  workerProfileId?: InputMaybe<Scalars['ID']['input']>;
};

export type MissionInvoice = {
  id: Scalars['ID']['output'];
  missionInfo: MissionInfo;
  totalAmount: Scalars['Int']['output'];
};

export type MissionOnboarding = {
  contactEmail: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  contactPhone: Maybe<Scalars['String']['output']>;
  instructions: Maybe<Scalars['String']['output']>;
  meetingAddress: Maybe<Address>;
  meetingAt: Maybe<Scalars['DateTime']['output']>;
};

export type MissionOvertimeStatus = {
  accountingDate: Maybe<Scalars['Date']['output']>;
  missionInfo: MissionInfo;
  overtimeHourlyInvoiceAmount: Scalars['Int']['output'];
  /**
   * Physical banked minutes of the mission: a banked minute counts 1:1 whatever its pay rate, so this under-states what the bank is worth as soon as premium buckets hold any of it. It is also a naive mission-level sum: it ignores the movements of a period that is not submitted yet, and the netting of a debt.
   *
   * Do not render it as the cash-out cap — that is PayrollBreakdown.cashableOvertimeMinutes — and prefer overtimeStandardEquivalentMinutes to display a balance.
   */
  overtimeMinutes: Scalars['Int']['output'];
  overtimePaidAtPercent: Scalars['Int']['output'];
  /** Value of the bank in standard (100%) minutes: a minute banked on a bucket compensated at rate R counts R/100 (a minute at 150% is worth 1.5), the plain pool counts at face value. This is the number to display as the balance. */
  overtimeStandardEquivalentMinutes: Scalars['Int']['output'];
};

export type MissionPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<Mission>;
  pageInfo: PageInfo;
};

export type MissionSalary = {
  grossAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  missionInfo: MissionInfo;
  payslip: Payslip;
};

export type MissionVacationSatus = {
  accountingDate: Maybe<Scalars['Date']['output']>;
  availablePendingVacationAmount: Scalars['Int']['output'];
  availablePendingVacationMinutes: Scalars['Int']['output'];
  availableVacationAmount: Scalars['Int']['output'];
  availableVacationMinutes: Scalars['Int']['output'];
  contractBaseSalary: Scalars['Int']['output'];
  contractHoursPerWeekFullTime: Scalars['Decimal']['output'];
  contractVacationDaysFullTime: Scalars['Decimal']['output'];
  contractVacationIndemnity: Scalars['Int']['output'];
  contractVacationMinutes: Scalars['Int']['output'];
  currentMonthAccumulatedAmount: Maybe<Scalars['Int']['output']>;
  currentMonthAccumulatedMinutes: Maybe<Scalars['Int']['output']>;
  currentYearTotalAllowedVacationMinutes: Scalars['Int']['output'];
  isVacationTracked: Scalars['Boolean']['output'];
  missionInfo: MissionInfo;
  previousYearAvailableVacationMinutes: Scalars['Int']['output'];
  /** @deprecated Use is_vacation_tracked instead */
  useVacationAccrual: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  acceptInvitation: Scalars['Boolean']['output'];
  /** This mutation, should be replaced by the signing process */
  acceptMissionContract: Mission;
  acceptTimeSheet: TimeSheet;
  acceptWorkerContract: WorkerProfile;
  /** @deprecated Use ack_activity_log2 instead */
  ackActivityLog: Maybe<ActivityLogItem>;
  ackActivityLog2: AckActivityLogResult;
  ackAllActivityLog: Scalars['Boolean']['output'];
  /** Link a worker of the caller's client to one of its client groups. Needs `worker.assign_group` in that client group. Idempotent. */
  assignWorkerToClientGroup: Scalars['Boolean']['output'];
  /** Cancel an amendment */
  cancelAmendment: MissionAmendment;
  cancelInvitation: Scalars['Boolean']['output'];
  /** Change the client signer for an amendment pending signature */
  changeAmendmentSigner: MissionAmendment;
  changeMissionOwner: Mission;
  changeMissionSigner: Mission;
  claimInvitation: InvitationCodeResponse;
  createAddress: Address;
  /** Creates a new amendment in draft state for the given mission */
  createAmendment: MissionAmendment;
  createBankAccount: BankAccount;
  createClientGroup: ClientGroup;
  createClientProfile: ClientProfile;
  createMission: Mission;
  createPrivateClientProfile: ClientProfile;
  createUser: User;
  createWorkerProfile: WorkerProfile;
  /** Delete a DRAFT amendment */
  deleteAmendment: Scalars['Boolean']['output'];
  deleteClientGroup: Scalars['Boolean']['output'];
  deleteCurrentProfile: Scalars['Boolean']['output'];
  deleteMission: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  generateAndSendMissionSimulationPdf: Scalars['Boolean']['output'];
  generateMissionContract: Scalars['Boolean']['output'];
  moveMission: Mission;
  regenerateAmendmentAssets: GenerateAmendmentAssetResult;
  regenerateContractAssets2: GenerateContractAssetResult;
  /** Reject an amendment when it is your turn to sign */
  rejectAmendment: MissionAmendment;
  rejectInvitation: Scalars['Boolean']['output'];
  rejectTimeSheet: TimeSheet;
  removeClientGroupMembership: Scalars['Boolean']['output'];
  removeWorkerFromClient: Scalars['Boolean']['output'];
  /** Unlink a worker from a client group. Needs `worker.assign_group` in that client group. Refused (`worker_has_contracts_in_client_group`) while the worker has a contract of that client group that has not ended. */
  removeWorkerFromClientGroup: Scalars['Boolean']['output'];
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** Reset a signing process for a given contract or amendment. The result will depend on the user role in the contract/amendment. The system will verify if he is a worker or a client and will automatically reset the signature process */
  resetSignatureProcess: SkribbleResetSigningProcessResult;
  /**
   * Reset a signing process for a given contract. Only failed or aborted processes can be reset
   * @deprecated Use reset_signature_process instead (mesoneer replacement)
   */
  resetSigningProcess: ResetSigningProcessResult;
  savePayrollBreakdown: PayrollBreakdown;
  saveTimeSheet: TimeSheet;
  sendClientInvitation: SendInvitationResponse;
  sendInvitation: SendInvitationResponse;
  setClientGroupMembership: ClientGroupMembership;
  setClientProfileRole: ClientProfile;
  /**
   * Sign several pending contracts in one action. Each id is checked independently and carries its own outcome: one failing contract never stops the others. Ticking a document is the signature intent, so the list shown to the user must make clear what is being signed.
   *
   * Signing happens out of band, so `scheduled: true` means queued, not signed. The rules for the caller:
   * 1. Every contract accepted here comes back with a non-null `signingScheduledAt`. Leave those out of the list you offer for signing — their signature is already on its way.
   * 2. `signingScheduledAt` clears itself. If a queued signature never completes, the contract reappears in the list on its own; nothing has to be reset and no state is stuck. A contract that comes back unsigned can simply be sent again.
   * 3. Sending the same contract twice is safe — the second signature is refused server-side, so a caller that lost its state (an app restart mid-batch) can never produce two signatures on one document. It is wasted work, not a risk.
   * 4. Progress is the list itself: a contract leaves it once it is signed. There is no batch id to poll.
   */
  signPendingContracts: SignPendingContractsResult;
  /** Start a user verification process */
  startIdentityVerification: VeriffStartVerificationResult;
  /** Create a sample signature request and return the URL to sign the document. */
  startSampleSignature: SkribbleSigninProcess;
  /** Start a signing process for a given contract or amendment. The result will depend on the user role in the contract/amendment. The system will verify if he is a worker or a client and will automatically choose the correct pdf to sign */
  startSignatureProcess: SkribbleSigninProcess;
  /**
   * Start a signing process for a given contract. The result will depend on the user role in the contract. The system will verify if he is a worker or a client and will automatically add framework contract asset if needed
   * @deprecated Use start_signature_process instead (mesoneer replacement)
   */
  startSigningProcess: SigninProcess;
  /** Submits an amendment for signing */
  submitAmendment: MissionAmendment;
  submitExactTimeSheet: TimeSheet;
  /** @deprecated Use submit_exact_time_sheet instead */
  submitFullTimeSheet: TimeSheet;
  submitLPPFundRegistration: LppRegistration;
  submitPayrollBreakdown: PayrollBreakdown;
  terminateMission: Maybe<Mission>;
  /** Updates an existing amendment in draft state */
  updateAmendment: MissionAmendment;
  updateClientGroup: ClientGroup;
  updateClientProfile: ClientProfile;
  updateDemoDocument: DemoDocument;
  updateInvitationClientGroups: Invitation;
  updateMission: Mission;
  updateMissionDocuments: Mission;
  updatePrivateClientProfile: ClientProfile;
  updateUser: User;
  updateWorkerProfile: WorkerProfile;
  /** Reset the verification process, only available on Kyc.rejected status */
  verificationReset: Scalars['String']['output'];
  /** Must be called when the Veriff process has ended */
  verificationSubmitted: Scalars['String']['output'];
};


export type MutationAcceptInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationAcceptMissionContractArgs = {
  missionId: Scalars['ID']['input'];
};


export type MutationAcceptTimeSheetArgs = {
  timeSheetId: Scalars['ID']['input'];
};


export type MutationAckActivityLogArgs = {
  logId: Scalars['UUID']['input'];
};


export type MutationAckActivityLog2Args = {
  logId: Scalars['UUID']['input'];
};


export type MutationAssignWorkerToClientGroupArgs = {
  clientGroupId: Scalars['ID']['input'];
  workerProfileId: Scalars['ID']['input'];
};


export type MutationCancelAmendmentArgs = {
  amendmentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationCancelInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type MutationChangeAmendmentSignerArgs = {
  amendmentId: Scalars['ID']['input'];
  clientUserId: Scalars['ID']['input'];
};


export type MutationChangeMissionOwnerArgs = {
  clientUserId: Scalars['ID']['input'];
  missionId: Scalars['ID']['input'];
};


export type MutationChangeMissionSignerArgs = {
  clientUserId: Scalars['ID']['input'];
  missionId: Scalars['ID']['input'];
};


export type MutationClaimInvitationArgs = {
  code: Scalars['String']['input'];
};


export type MutationCreateAddressArgs = {
  address: AddressInput;
};


export type MutationCreateAmendmentArgs = {
  input: CreateAmendmentInput;
};


export type MutationCreateBankAccountArgs = {
  bankAccount: BankAccountInput;
};


export type MutationCreateClientGroupArgs = {
  clientGroup: ClientGroupInput;
};


export type MutationCreateClientProfileArgs = {
  clientProfile: ClientProfileInput;
};


export type MutationCreateMissionArgs = {
  generateContractAsset?: InputMaybe<Scalars['Boolean']['input']>;
  missionData: MissionInput;
};


export type MutationCreatePrivateClientProfileArgs = {
  privateClientProfile: PrivateClientProfileInput;
};


export type MutationCreateUserArgs = {
  userData: UserInput;
};


export type MutationCreateWorkerProfileArgs = {
  workerProfile: WorkerProfileInput;
};


export type MutationDeleteAmendmentArgs = {
  amendmentId: Scalars['ID']['input'];
};


export type MutationDeleteClientGroupArgs = {
  clientGroupId: Scalars['ID']['input'];
};


export type MutationDeleteMissionArgs = {
  missionId: Scalars['ID']['input'];
};


export type MutationGenerateAndSendMissionSimulationPdfArgs = {
  email: Scalars['String']['input'];
  includeContractExamples: Scalars['Boolean']['input'];
  includePdfDetails: Scalars['Boolean']['input'];
  missionData: MissionInput;
  workerData: WorkerInfoInput;
};


export type MutationGenerateMissionContractArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationMoveMissionArgs = {
  clientGroupId: Scalars['ID']['input'];
  missionId: Scalars['ID']['input'];
};


export type MutationRegenerateAmendmentAssetsArgs = {
  amendmentId: Scalars['ID']['input'];
};


export type MutationRegenerateContractAssets2Args = {
  contractId: Scalars['ID']['input'];
};


export type MutationRejectAmendmentArgs = {
  amendmentId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationRejectInvitationArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRejectTimeSheetArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  timeSheetId: Scalars['ID']['input'];
};


export type MutationRemoveClientGroupMembershipArgs = {
  clientGroupId: Scalars['ID']['input'];
  clientProfileId: Scalars['ID']['input'];
};


export type MutationRemoveWorkerFromClientArgs = {
  workerProfileId: Scalars['ID']['input'];
};


export type MutationRemoveWorkerFromClientGroupArgs = {
  clientGroupId: Scalars['ID']['input'];
  workerProfileId: Scalars['ID']['input'];
};


export type MutationResendVerificationEmailArgs = {
  clientProfile: Scalars['Boolean']['input'];
};


export type MutationResetSignatureProcessArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationResetSigningProcessArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationSavePayrollBreakdownArgs = {
  payrollBreakdownId: Scalars['ID']['input'];
  payrollBreakdownInput: PayrollBreakdownInput;
};


export type MutationSaveTimeSheetArgs = {
  timeSheetId: Scalars['ID']['input'];
  trackingDates: Array<DateScheduleInput>;
};


export type MutationSendClientInvitationArgs = {
  clientGroupRoles?: InputMaybe<Array<ClientGroupRoleInput>>;
  clientRole?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendInvitationArgs = {
  clientGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetClientGroupMembershipArgs = {
  clientGroupId: Scalars['ID']['input'];
  clientProfileId: Scalars['ID']['input'];
  role: Scalars['String']['input'];
};


export type MutationSetClientProfileRoleArgs = {
  clientProfileId: Scalars['ID']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSignPendingContractsArgs = {
  contractIds: Array<Scalars['ID']['input']>;
};


export type MutationStartSampleSignatureArgs = {
  data?: InputMaybe<SkribbleSampleSignatureInput>;
};


export type MutationStartSignatureProcessArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationStartSigningProcessArgs = {
  contractId: Scalars['ID']['input'];
};


export type MutationSubmitAmendmentArgs = {
  amendmentId: Scalars['ID']['input'];
};


export type MutationSubmitExactTimeSheetArgs = {
  timeSheetId: Scalars['ID']['input'];
  trackingDates: Array<DateScheduleInput>;
};


export type MutationSubmitFullTimeSheetArgs = {
  timeSheetId: Scalars['ID']['input'];
};


export type MutationSubmitLppFundRegistrationArgs = {
  fundId: Scalars['ID']['input'];
  registrationFormData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationSubmitPayrollBreakdownArgs = {
  payrollBreakdownId: Scalars['ID']['input'];
  payrollBreakdownInput: PayrollBreakdownInput;
};


export type MutationTerminateMissionArgs = {
  data: TerminationDataInput;
  missionId: Scalars['ID']['input'];
};


export type MutationUpdateAmendmentArgs = {
  amendmentId: Scalars['ID']['input'];
  input: UpdateAmendmentInput;
};


export type MutationUpdateClientGroupArgs = {
  clientGroup: ClientGroupInput;
  clientGroupId: Scalars['ID']['input'];
};


export type MutationUpdateClientProfileArgs = {
  clientProfile: ClientProfileInput;
};


export type MutationUpdateDemoDocumentArgs = {
  changes: DemoDocumentChanges;
  id: Scalars['ID']['input'];
};


export type MutationUpdateInvitationClientGroupsArgs = {
  clientGroupIds: Array<Scalars['ID']['input']>;
  invitationId: Scalars['ID']['input'];
};


export type MutationUpdateMissionArgs = {
  generateContractAsset?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  missionData: MissionInput;
};


export type MutationUpdateMissionDocumentsArgs = {
  documents: Array<DocumentInput>;
  missionId: Scalars['ID']['input'];
};


export type MutationUpdatePrivateClientProfileArgs = {
  privateClientProfile: PrivateClientProfileInput;
};


export type MutationUpdateUserArgs = {
  userData: UserInput;
};


export type MutationUpdateWorkerProfileArgs = {
  workerProfile: WorkerProfileInput;
};

export type OvertimePaidAmount = {
  amount: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  payRatePercent: Scalars['Int']['output'];
};

export type PageInfo = {
  currentOffset: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nextOffset: Maybe<Scalars['Int']['output']>;
  previousOffset: Maybe<Scalars['Int']['output']>;
};

export type PayrollBreakdown = {
  absences: Array<Absence>;
  auxiliarySalaries: Array<AuxiliarySalary>;
  bonuses: Array<Bonus>;
  /**
   * Bank minutes the client may cash on THIS payroll breakdown through PayrollBreakdownInput.overtimePaidMinutes: the mission bank as it stands here, premium buckets included, its debt already netted. This is the cash-out cap — a submit rejects more than this — so render it next to the cash-out field.
   *
   * It legitimately differs from missionOvertimeStatus.overtimeMinutes, which is a mission-level naive sum that ignores this period's own movements and the netting; showing that one next to a cash-out field accepting a different number is what generates support tickets. For a balance to DISPLAY, prefer missionOvertimeStatus.overtimeStandardEquivalentMinutes.
   */
  cashableOvertimeMinutes: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use deltaWorkBalance */
  deltaWork: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use deltaWorkBalance and workItems */
  deltaWork100: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  deltaWork115: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  deltaWork125: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  deltaWork150: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  deltaWork200: Maybe<Scalars['Int']['output']>;
  /** Signed standard (100%) bank pool movement of this period, in minutes: > 0 banked, < 0 taken back as time off. Only the part of the movement that carries no premium — the premium buckets keep theirs in workItems. */
  deltaWorkBalance: Maybe<Scalars['Int']['output']>;
  dynamicDeductions: Array<DynamicDeduction>;
  dynamicFees: Array<DynamicFee>;
  effectiveFees: Array<EffectiveFee>;
  endDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isExtraMonth: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  missionInfo: MissionInfo;
  /** @deprecated Use overtimePaidBalance and workItems */
  overtimePaid100: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  overtimePaid115: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  overtimePaid125: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  overtimePaid150: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  overtimePaid200: Maybe<Scalars['Int']['output']>;
  /** The overtime cashed out on this payroll breakdown, per pay rate, with what the worker's payslip pays for it (cents): the standard pool at the CCT overtime rate (125% on some CCTs), each bucket at its own rate. Hours taken back as time off are not included. */
  overtimePaidAmounts: Array<OvertimePaidAmount>;
  /** Standard (100%) pool minutes cashed out on this payroll breakdown, in minutes. Paid at the CCT overtime rate, which is derived when the payroll lines are built. */
  overtimePaidBalance: Maybe<Scalars['Int']['output']>;
  /** The client's choice for paying this contract's 13th salary out on this period — 13x contracts only (those whose 13th salary is paid out separately instead of with every salary). null = automatic (paid out on the December period and on the contract's last period regardless); true = pay it out here too; false = do not (refused on December and on the contract's last period, where it is always due). Always null on a contract that pays its 13th salary with every salary. */
  release13thSalary: Maybe<Scalars['Boolean']['output']>;
  /** Whether the 13th salary is actually paid out on this period — the effective outcome of releaseThirteenthSalary plus the always-due rule (December, the contract's last period). Always false on a contract that pays its 13th salary with every salary. The amount is not reported: payroll holds the provision and pays out what it has accumulated. Frozen once the period is submitted or paid. */
  releases13thSalary: Scalars['Boolean']['output'];
  startDate: Scalars['Date']['output'];
  status: PayrollBreakdownStatus;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  submittedBy: Maybe<UserInfo>;
  summary: PayrollBreakdownSummary;
  timesheets: Array<TimeSheet>;
  /** @deprecated Use used_vacation_minutes instead */
  totalVacationDays: Maybe<Scalars['Decimal']['output']>;
  /** @deprecated Use workItems */
  totalWork100: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  totalWork115: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  totalWork125: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  totalWork150: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use workItems */
  totalWork200: Maybe<Scalars['Int']['output']>;
  totalWorkedDays: Maybe<Scalars['Decimal']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usedVacationAmount: Maybe<Scalars['Int']['output']>;
  usedVacationMinutes: Maybe<Scalars['Int']['output']>;
  /**
   * The per-bucket work ledger of the period: what was worked, banked and cashed on each hour bucket, with the two rates the bucket is valued at.
   *
   * payRatePercent is what the CCT pays for the bucket, not necessarily what this period cashes: on a monthly mission that does not compensate overtime, a bucket whose compensationRatePercent is 100 carries no premium here. Its minutes are salary work ( they count in deltaWorkBalance like any plain hour, and the deprecated totalWork<rate> fields report them at 100 ), and the uplift is paid when the pool is cashed.
   */
  workItems: Array<PayrollBreakdownWorkItem>;
  yearMonth: Scalars['Date']['output'];
};

export type PayrollBreakdownInput = {
  absences?: InputMaybe<Array<AbsenceInput>>;
  /** Auxiliary activities paid as a lump sum: a title, the hours it covers (minutes) and the all-inclusive gross price (cents, vacation and public-holiday indemnities included). Only for hourly missions without overtime compensation — anything else is an error. Omitting the field keeps the value of an earlier save; sending it replaces that value. */
  auxiliarySalaries?: InputMaybe<Array<AuxiliarySalaryInput>>;
  bonuses?: InputMaybe<Array<BonusInput>>;
  /** @deprecated Removed from the input: the bank movements are derived from workItems */
  deltaWork?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Removed from the input: the bank movements are derived from workItems */
  deltaWork100?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Removed from the input: the bank movements are derived from workItems */
  deltaWork115?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Removed from the input: the bank movements are derived from workItems */
  deltaWork125?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Removed from the input: the bank movements are derived from workItems */
  deltaWork150?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Removed from the input: the bank movements are derived from workItems */
  deltaWork200?: InputMaybe<Scalars['Float']['input']>;
  dynamicDeductions?: InputMaybe<Array<DynamicDeductionInput>>;
  dynamicFees?: InputMaybe<Array<DynamicFeeInput>>;
  effectiveFees?: InputMaybe<Array<EffectiveFeeInput>>;
  /** @deprecated Use overtimePaidMinutes */
  overtimePaid100?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use overtimePaidMinutes */
  overtimePaid115?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use overtimePaidMinutes */
  overtimePaid125?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use overtimePaidMinutes */
  overtimePaid150?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use overtimePaidMinutes */
  overtimePaid200?: InputMaybe<Scalars['Float']['input']>;
  /** Bank minutes to cash out on this payroll breakdown, mid mission. The server picks where they come from (premium buckets first, plain pool last) and each is paid at its own rate. Capped by PayrollBreakdown.cashableOvertimeMinutes; more than that is rejected. */
  overtimePaidMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** This period's choice for paying the 13th salary out — 13x contracts only (those whose 13th salary is paid out separately instead of with every salary). null (the default) means automatic: paid out on the December period and on the contract's last period regardless. true pays it out on this period too; false refuses to, and is rejected on the December period and on the contract's last period, where it is always due. true/false on a contract that pays its 13th salary with every salary is rejected. Omitting the field keeps the value of an earlier save; sending null explicitly returns it to automatic. */
  release13thSalary?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use usedVacationMinutes */
  totalVacationDays?: InputMaybe<Scalars['Decimal']['input']>;
  /** @deprecated Use workItems: the rate of a bucket is derived from the contract */
  totalWork100?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use workItems: the rate of a bucket is derived from the contract */
  totalWork115?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use workItems: the rate of a bucket is derived from the contract */
  totalWork125?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use workItems: the rate of a bucket is derived from the contract */
  totalWork150?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated Use workItems: the rate of a bucket is derived from the contract */
  totalWork200?: InputMaybe<Scalars['Float']['input']>;
  totalWorkedDays?: InputMaybe<Scalars['Decimal']['input']>;
  /** @deprecated Derived from usedVacationMinutes */
  usedVacationAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Vacation minutes taken in the period. They count toward the contract hours, so they feed the overage. Omitting the field keeps the value of an earlier save; sending it replaces that value. */
  usedVacationMinutes?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Worked minutes per hour bucket. Declare only WHAT was worked: the rates come from the contract and the banking is derived from the period overage.
   *
   * Only for missions with payrollSource = manual_client — sending it on a lift mission is an error, its work comes from the timesheets. Cannot be combined with the deprecated per-rate fields.
   */
  workItems?: InputMaybe<Array<PayrollBreakdownWorkItemInput>>;
};

export type PayrollBreakdownPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<PayrollBreakdown>;
  pageInfo: PageInfo;
};

export enum PayrollBreakdownStatus {
  Open = 'open',
  Paid = 'paid',
  Submitted = 'submitted'
}

export type PayrollBreakdownSummary = {
  needProcessing: Scalars['Boolean']['output'];
  rows: Array<SummaryRow>;
};

export type PayrollBreakdownWorkItem = {
  compensationRatePercent: Maybe<Scalars['Int']['output']>;
  deltaWork: Scalars['Int']['output'];
  itemType: WorkingTimeDurationBreakdownItemType;
  overtimePaid: Scalars['Int']['output'];
  payRatePercent: Scalars['Int']['output'];
  totalWork: Scalars['Int']['output'];
};

export type PayrollBreakdownWorkItemInput = {
  itemType: WorkingTimeDurationBreakdownItemType;
  totalWork: Scalars['Int']['input'];
};

export enum PayrollSourceType {
  Gekos = 'gekos',
  Lift = 'lift',
  ManualClient = 'manual_client'
}

export type Payslip = {
  asset: Maybe<Asset>;
  grossAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  missionInfo: MissionInfo;
  month: Scalars['Int']['output'];
  netAmount: Scalars['Int']['output'];
  paidDate: Maybe<Scalars['Date']['output']>;
  year: Scalars['Int']['output'];
  yearMonth: Scalars['Date']['output'];
};

export type PayslipPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<Payslip>;
  pageInfo: PageInfo;
};

export type Person = {
  avsNumber: Maybe<Scalars['String']['output']>;
  birthdate: Maybe<Scalars['DateTime']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Gender>;
  id: Scalars['ID']['output'];
  inFirstEducation: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  monthlySalary: Maybe<Scalars['Int']['output']>;
  /** The partner's nationality, an ISO 3166-1 alpha-2 code */
  nationality: Maybe<Scalars['String']['output']>;
  permitType: Maybe<WorkingPermitType>;
};

export type PersonInput = {
  avsNumber?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['DateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inFirstEducation?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  monthlySalary?: InputMaybe<Scalars['Int']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  permitType?: InputMaybe<WorkingPermitType>;
};

/** Private client activity type, used to fill createMission mutation for private clients */
export type PrivateClientActivityType = {
  activityTypeId: Scalars['ID']['output'];
  cctEditionId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  laaActivityType: LaaActivityType;
  name: Scalars['String']['output'];
};

export type PrivateClientInput = {
  hoursPerWeekFullTime?: InputMaybe<Scalars['Float']['input']>;
  ijmGroupId?: InputMaybe<Scalars['String']['input']>;
  ijmPayFirstDays?: InputMaybe<Scalars['Boolean']['input']>;
  ijmPayRemainingPercents?: InputMaybe<Scalars['Int']['input']>;
};

export type PrivateClientProfileInput = {
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<PrivateClientInput>;
  user?: InputMaybe<UserInput>;
};

export enum ProfileType {
  Client = 'client',
  Worker = 'worker'
}

export type Query = {
  /** @deprecated Use clientInvitations or onboardingInvitations */
  allInvitations: InvitationPageResult;
  clientInvitationsSent: Array<Invitation>;
  /** The roles a client assigns to its client profiles, with what each allows and where it can be held */
  clientRoles: Array<ClientRole>;
  currentUser: Maybe<User>;
  findActivityType: ActivityTypePageResult;
  findCct: CctPageResult;
  findClientInfo: ClientInfoPageResult;
  findDemoDocuments: DemoDocumentPageResult;
  findMissionAuditLogs: AuditLogPageResult;
  findMissionInvoices: InvoicePageResult;
  findMissionPayrollBreakdown: PayrollBreakdownPageResult;
  findMissionTimeSheets: TimeSheetPageResult;
  findMyInvoices: InvoicePageResult;
  findMyMissions: MissionPageResult;
  findMyPayslips: PayslipPageResult;
  findMySalaries: SalaryPageResult;
  findPendingTimeSheets: TimeSheetPageResult;
  findWorkerInfo: WorkerInfoPageResult;
  findWorkerInvoices: InvoicePageResult;
  findWorkerMissions: MissionPageResult;
  findWorkerTimeSheets: TimeSheetPageResult;
  getActivitiesInfo: Maybe<ActivitiesInfo>;
  getActivityLogFeed: ActivityLogItemPageResult;
  getActivityTodoFeed: Array<ActivityTodoItem>;
  getAllProfilesActivitiesInfo: Array<ActivitiesInfo>;
  getAllTimeSheets: TimeSheetPageResult;
  getAmendment: Maybe<MissionAmendment>;
  getAmendmentSigningUrl: Maybe<Scalars['String']['output']>;
  getAsset: Maybe<Asset>;
  getBankDetailsForIban: Maybe<BankDetails>;
  getCctByEditionId: Maybe<Cct>;
  getCctDetailsFieldValues: Array<CctDetailsFieldValue>;
  getCctDetailsFieldValuesFromParent: Array<CctDetailsFieldValue>;
  getCctDetailsFields: Array<CctDetailsField>;
  getClientInfo: Maybe<ClientInfo>;
  getClientUsers: Array<ClientUser>;
  getClientWorkers: Array<WorkerInfo>;
  getContract: Maybe<Contract>;
  /**
   * Return the status of a contract signing process. The result will depend on the user role in the contract (worker or client).
   * @deprecated use contract.signature_status instead
   */
  getContractSignatureStatus: ContractSignatureStatusResult;
  /**
   * Return the status of a contract signing process. The result will depend on the user role in the contract (worker or client).
   * @deprecated Use get_contract_signature_status instead (mesoneer replacement)
   */
  getContractSigningStatus: ContractSigning;
  getCurrentEditableAmendment: Maybe<MissionAmendment>;
  getCurrentLegalEmployer: LegalEmployer;
  /** @deprecated Do not use it anymore, invitation are handled in anther way */
  getDefaultProfileType: Maybe<ProfileType>;
  getDemoDocument: Maybe<DemoDocument>;
  getDurationBreakdown: TrackedDurationBreakdownType;
  getIjmChoices: Array<IjmChoice>;
  getIjmGroups: Array<IjmGroup>;
  getInvitation: Maybe<Invitation>;
  getInvoice: Maybe<Invoice>;
  getLaacGroups: Array<LaacGroup>;
  getLppPlans: Array<LppPlan>;
  getMission: Maybe<Mission>;
  getMissionAmendments: Array<MissionAmendment>;
  getMissionCancellationRequest: Maybe<MissionCancellationRequest>;
  getMissionOvertimeStatus: MissionOvertimeStatus;
  getMissionVacationAccumulationMinutesForPayrollBreakdown: Scalars['Int']['output'];
  getMissionVacationStatus: MissionVacationSatus;
  getPayrollBreakdown: PayrollBreakdown;
  getPayrollBreakdownSummary: PayrollBreakdownSummary;
  getPayslip: Maybe<Payslip>;
  getPrivateClientActivityTypes: Array<PrivateClientActivityType>;
  getSalary: Maybe<Salary>;
  getSalaryDetails: SalaryDetails;
  getSalaryForecast: Array<SalaryForecast>;
  getTerminationInfo: TerminationInfo;
  getTimeSheet: TimeSheet;
  /** @deprecated Use get_activities_info instead */
  getUnreadActivities: Scalars['Int']['output'];
  /** Returns a info about the valid dates for applying an amendment to the mission that impact the payroll (gross_salary) */
  getValidAmendmentApplyDates: AmendmentValidDatesResult;
  getWorkerInfo: Maybe<WorkerInfo>;
  identity: Maybe<Scalars['JSON']['output']>;
  invitationByCode: InvitationCodeResponse;
  onboardingInvitationsReceived: Array<Invitation>;
  status: Scalars['String']['output'];
  workerInvitationsSent: Array<Invitation>;
};


export type QueryAllInvitationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindActivityTypeArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QueryFindCctArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  useLse?: Scalars['Boolean']['input'];
};


export type QueryFindClientInfoArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QueryFindDemoDocumentsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindMissionAuditLogsArgs = {
  limit?: Scalars['Int']['input'];
  missionId: Scalars['ID']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindMissionInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  missionId: Scalars['ID']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindMissionPayrollBreakdownArgs = {
  limit?: Scalars['Int']['input'];
  missionId: Scalars['ID']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindMissionTimeSheetsArgs = {
  limit?: Scalars['Int']['input'];
  missionId: Scalars['ID']['input'];
  offset?: Scalars['Int']['input'];
  statusIn?: InputMaybe<Array<TimeSheetState>>;
};


export type QueryFindMyInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindMyMissionsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  profileType?: InputMaybe<ProfileType>;
};


export type QueryFindMyPayslipsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindMySalariesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindPendingTimeSheetsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryFindWorkerInfoArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  query: Scalars['String']['input'];
};


export type QueryFindWorkerInvoicesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  workerProfileId: Scalars['ID']['input'];
};


export type QueryFindWorkerMissionsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  workerProfileId: Scalars['ID']['input'];
};


export type QueryFindWorkerTimeSheetsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  statusIn?: InputMaybe<Array<TimeSheetState>>;
  workerProfileId: Scalars['ID']['input'];
};


export type QueryGetActivityLogFeedArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryGetAllTimeSheetsArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  statusIn?: InputMaybe<Array<TimeSheetState>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryGetAmendmentArgs = {
  amendmentId: Scalars['ID']['input'];
};


export type QueryGetAmendmentSigningUrlArgs = {
  amendmentId: Scalars['ID']['input'];
};


export type QueryGetAssetArgs = {
  assetId: Scalars['ID']['input'];
};


export type QueryGetBankDetailsForIbanArgs = {
  iban: Scalars['String']['input'];
};


export type QueryGetCctByEditionIdArgs = {
  cctEditionId: Scalars['String']['input'];
};


export type QueryGetCctDetailsFieldValuesArgs = {
  cctEditionId: Scalars['String']['input'];
  criteriaStructureId: Scalars['Int']['input'];
  parentValue: CctDetailsFieldValueInput;
};


export type QueryGetCctDetailsFieldValuesFromParentArgs = {
  cctEditionId: Scalars['String']['input'];
  criteriaStructureId: Scalars['Int']['input'];
  parentValues: Array<CctDetailsFieldValueInput>;
};


export type QueryGetCctDetailsFieldsArgs = {
  cctEditionId: Scalars['String']['input'];
};


export type QueryGetClientInfoArgs = {
  clientProfileId: Scalars['ID']['input'];
};


export type QueryGetClientUsersArgs = {
  clientId: Scalars['ID']['input'];
};


export type QueryGetContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetContractSignatureStatusArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryGetContractSigningStatusArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryGetCurrentEditableAmendmentArgs = {
  missionId: Scalars['ID']['input'];
};


export type QueryGetDemoDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDurationBreakdownArgs = {
  missionId: Scalars['ID']['input'];
  trackingDates: Array<DateScheduleInput>;
};


export type QueryGetInvitationArgs = {
  invitationId: Scalars['ID']['input'];
};


export type QueryGetInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type QueryGetLppPlansArgs = {
  cctContractId: Scalars['String']['input'];
};


export type QueryGetMissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMissionAmendmentsArgs = {
  includeRejected?: Scalars['Boolean']['input'];
  missionId: Scalars['ID']['input'];
};


export type QueryGetMissionCancellationRequestArgs = {
  missionId: Scalars['ID']['input'];
};


export type QueryGetMissionOvertimeStatusArgs = {
  missionId: Scalars['ID']['input'];
};


export type QueryGetMissionVacationAccumulationMinutesForPayrollBreakdownArgs = {
  payrollBreakdownId: Scalars['ID']['input'];
};


export type QueryGetMissionVacationStatusArgs = {
  missionId: Scalars['ID']['input'];
};


export type QueryGetPayrollBreakdownArgs = {
  payrollBreakdownId: Scalars['ID']['input'];
};


export type QueryGetPayrollBreakdownSummaryArgs = {
  payrollBreakdownId: Scalars['ID']['input'];
  payrollBreakdownInput: PayrollBreakdownInput;
};


export type QueryGetPayslipArgs = {
  payslipId: Scalars['ID']['input'];
};


export type QueryGetPrivateClientActivityTypesArgs = {
  legalEmployerId?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSalaryArgs = {
  salaryId: Scalars['ID']['input'];
};


export type QueryGetSalaryDetailsArgs = {
  activityTypeId?: InputMaybe<Scalars['String']['input']>;
  cctDetailsValues?: InputMaybe<Array<CctDetailsFieldValueInput>>;
  cctEditionId: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
  disableAvsSmallSalaryExemption?: Scalars['Boolean']['input'];
  earningType?: EarningType;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forceLpp?: Scalars['Boolean']['input'];
  has13thSalary?: InputMaybe<Scalars['Boolean']['input']>;
  hoursPerWeekFullTime?: Scalars['Decimal']['input'];
  ijmGroupId?: InputMaybe<Scalars['String']['input']>;
  laaActivityType?: InputMaybe<LaaActivityType>;
  laacGroupId?: InputMaybe<Scalars['String']['input']>;
  legalEmployerId?: Scalars['String']['input'];
  lppPlanId?: InputMaybe<Scalars['String']['input']>;
  missionStateCode?: Scalars['String']['input'];
  pay13thSalaryWithSalary?: InputMaybe<Scalars['Boolean']['input']>;
  payVacationIndemnityWithSalary?: Scalars['Boolean']['input'];
  requestedSalary?: InputMaybe<Scalars['Int']['input']>;
  requestedSalaryType?: SalaryType;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  vacationDays?: Scalars['Int']['input'];
  workerProfileId: Scalars['String']['input'];
  workerProfileInfo?: InputMaybe<WorkerInfoInput>;
  workingTimeClassicSpec?: InputMaybe<WorkingTimeClassicInput>;
};


export type QueryGetSalaryForecastArgs = {
  contractEndDate?: InputMaybe<Scalars['Date']['input']>;
  contractId?: InputMaybe<Scalars['ID']['input']>;
  contractStartDate: Scalars['Date']['input'];
  deductions?: InputMaybe<Array<MissionDeductionInput>>;
  deferredIndemnity?: Scalars['Int']['input'];
  earningType: EarningType;
  fees?: Array<MissionFeeInput>;
  forWorker?: InputMaybe<Scalars['Boolean']['input']>;
  grossSalary: Scalars['Int']['input'];
  has13thSalary?: InputMaybe<Scalars['Boolean']['input']>;
  hoursPerWeekFullTime?: Scalars['Float']['input'];
  invoiceSalary: Scalars['Int']['input'];
  monthYear: Scalars['Date']['input'];
  nbMonths?: Scalars['Int']['input'];
  netSalary: Scalars['Int']['input'];
  pay13thSalaryWithSalary?: InputMaybe<Scalars['Boolean']['input']>;
  thirteenMonthCompensation?: Scalars['Int']['input'];
  workerDeductions?: InputMaybe<Array<SalaryForecastDeductionInput>>;
  workingAddressStateCode?: InputMaybe<Scalars['String']['input']>;
  workingTimeClassicSpec: WorkingTimeClassicInput;
  workingTimeScheduleSpec?: InputMaybe<WorkingTimeScheduleInput>;
  workingTimeSpecificSpec?: InputMaybe<WorkingTimeSpecificInput>;
};


export type QueryGetTerminationInfoArgs = {
  missionId: Scalars['ID']['input'];
};


export type QueryGetTimeSheetArgs = {
  timeSheetId: Scalars['ID']['input'];
};


export type QueryGetValidAmendmentApplyDatesArgs = {
  data: AmendmentValidDatesInput;
  missionId: Scalars['ID']['input'];
};


export type QueryGetWorkerInfoArgs = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  workerProfileId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvitationByCodeArgs = {
  code: Scalars['String']['input'];
};

export enum RejectedByType {
  Lift = 'lift',
  User = 'user'
}

export enum Repetition {
  Day = 'day',
  Month = 'month',
  None = 'none',
  OnDemand = 'on_demand',
  Week = 'week',
  Week2 = 'week2',
  Week3 = 'week3',
  Week4 = 'week4'
}

export enum RepetitionType {
  Count = 'count',
  WorkedDay = 'worked_day',
  WorkedMonth = 'worked_month'
}

/** Reset signing process result */
export type ResetSigningProcessResult = {
  success: Scalars['Boolean']['output'];
};

export enum RoleLevel {
  Client = 'client',
  ClientGroup = 'client_group'
}

export type Salary = {
  grossAmount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  missionSalaries: Array<MissionSalary>;
  /** @deprecated Use `mission_salaries` instead */
  missionsInfo: Array<MissionInfo>;
  month: Scalars['Int']['output'];
  netAmount: Scalars['Int']['output'];
  paidAt: Maybe<Scalars['DateTime']['output']>;
  payslips: Array<Payslip>;
  salaryAsset: Maybe<Asset>;
  year: Scalars['Int']['output'];
  yearMonth: Scalars['Date']['output'];
};

/** Social deduction */
export type SalaryDeductionType = {
  amount: Scalars['Int']['output'];
  appliedMonthly: Scalars['Boolean']['output'];
  i18nValue: Maybe<Scalars['String']['output']>;
  intercomArticleId: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  rate: Scalars['Decimal']['output'];
  title: Scalars['String']['output'];
};

export type SalaryDetails = {
  baseSalary: Scalars['Int']['output'];
  clientDeductions: Maybe<Array<SalaryDeductionType>>;
  clientMissionFeesRate: Scalars['Decimal']['output'];
  contributionBase: Scalars['Int']['output'];
  deferredIndemnity: Scalars['Int']['output'];
  grossSalary: Scalars['Int']['output'];
  has13thSalary: Scalars['Boolean']['output'];
  invoiceSalary: Scalars['Int']['output'];
  lppAmountToBeDefined: Scalars['Boolean']['output'];
  lppPlan: Maybe<LppPlan>;
  lseMargin: Scalars['Int']['output'];
  mandatory13thMonth: Scalars['Boolean']['output'];
  minBaseSalary: Scalars['Int']['output'];
  minGrossSalary: Scalars['Int']['output'];
  minInvoiceSalary: Scalars['Int']['output'];
  minNetSalary: Scalars['Int']['output'];
  minVacationDays: Scalars['Int']['output'];
  netSalary: Scalars['Int']['output'];
  pay13thSalaryWithSalary: Scalars['Boolean']['output'];
  publicHolidaysCompensation: Scalars['Int']['output'];
  requestedSalary: Scalars['Int']['output'];
  requestedSalaryType: SalaryType;
  thirteenMonthCompensation: Scalars['Int']['output'];
  totalClientDeductions: Scalars['Int']['output'];
  totalCompensation: Scalars['Int']['output'];
  totalWorkerDeductions: Scalars['Int']['output'];
  vacationCompensation: Scalars['Int']['output'];
  vacationDays: Scalars['Int']['output'];
  workerDeductions: Maybe<Array<SalaryDeductionType>>;
};

export type SalaryForecast = {
  grossSalary: Scalars['Int']['output'];
  includedClientDeductionsAmount: Scalars['Int']['output'];
  includedDeductionsAmount: Scalars['Int']['output'];
  includedFeesAmount: Scalars['Int']['output'];
  includedWorkerDeductionsAmount: Scalars['Int']['output'];
  invoiceSalary: Scalars['Int']['output'];
  monthEndDate: Scalars['Date']['output'];
  monthStartDate: Scalars['Date']['output'];
  monthYear: Scalars['Date']['output'];
  netSalary: Scalars['Int']['output'];
};

export type SalaryForecastDeductionInput = {
  appliedMonthly?: Scalars['Boolean']['input'];
  rate: Scalars['Decimal']['input'];
  title: Scalars['String']['input'];
};

export type SalaryPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<Salary>;
  pageInfo: PageInfo;
};

export enum SalaryType {
  Base = 'base',
  Gross = 'gross',
  Invoice = 'invoice',
  Net = 'net'
}

export type ScheduleInput = {
  endTime: Scalars['Int']['input'];
  startTime: Scalars['Int']['input'];
  type?: ScheduleTimeType;
};

export enum ScheduleTimeType {
  Accident = 'accident',
  DeathCloseRelative = 'death_close_relative',
  Marriage = 'marriage',
  Maternity = 'maternity',
  Military = 'military',
  Moving = 'moving',
  Other = 'other',
  PublicHoliday = 'public_holiday',
  Sickness = 'sickness',
  SicknessCloseRelative = 'sickness_close_relative',
  Trainee = 'trainee',
  Vacation = 'vacation',
  Work = 'work'
}

export type ScheduleType = {
  endTime: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
  type: ScheduleTimeType;
};

export type SendInvitationError = {
  message: Scalars['String']['output'];
  messageKey: Scalars['String']['output'];
};

export type SendInvitationResponse = SendInvitationError | SendInvitationSuccess;

export enum SendInvitationResult {
  AlreadyLinked = 'already_linked',
  Invited = 'invited'
}

export type SendInvitationSuccess = {
  newInvitation: Scalars['Boolean']['output'];
  result: SendInvitationResult;
  resultMessage: Maybe<Scalars['String']['output']>;
  workerProfileId: Maybe<Scalars['ID']['output']>;
};

/** Why one contract of a batch was not signed; null when it was. */
export enum SignPendingContractError {
  ContractNotFound = 'contract_not_found',
  DocumentNotReady = 'document_not_ready',
  NotAllowed = 'not_allowed',
  NotYourTurn = 'not_your_turn'
}

/** Outcome for one contract of a batch signing request. */
export type SignPendingContractOutcome = {
  /** The contract this outcome is about. */
  contractId: Scalars['ID']['output'];
  /** Human-readable failure message. */
  error: Maybe<Scalars['String']['output']>;
  /** Why it was not signed; null when it was. */
  errorCode: Maybe<SignPendingContractError>;
  /** True when a signature was queued for this contract. Queued, not signed: the contract keeps its current signature state until the signature completes, and its `signingScheduledAt` is now set. */
  scheduled: Scalars['Boolean']['output'];
};

/** Result of signing several pending contracts in one action. */
export type SignPendingContractsResult = {
  /** One entry per requested contract, in the order they were given. */
  outcomes: Array<SignPendingContractOutcome>;
  /** How many signatures were queued. */
  scheduledCount: Scalars['Int']['output'];
};

export enum SignatureCapacity {
  Individual = 'individual',
  Procuration = 'procuration'
}

export enum SignatureQuality {
  Aes = 'AES',
  AesMinimal = 'AES_MINIMAL',
  Demo = 'DEMO',
  Qes = 'QES',
  Ses = 'SES'
}

/** The result of the signing process of a contract, this is liked to the user that call the mutation, it will change depending if you are a client or a worker */
export type SigninProcess = {
  /** Mesoneer basket status of the signature process.This is linked to the user calling this mutation, if there is multiple signer in the basket, only the status of the current caller is returned */
  basketStatus: DocumentBasketStatus;
  /** Mesoneer case status of the identification process. This is linked to the user calling this mutation, not the process itself */
  identStatus: MesoneerUbiIdStatus;
  identUrl: Maybe<Scalars['String']['output']>;
  /** Tell if the signing process will handle the framework contract also */
  needToSignFrameworkContract: Scalars['Boolean']['output'];
  signUrl: Maybe<Scalars['String']['output']>;
  /** The current state of the signing process, this is the field to check to know what to display to the user */
  state: SigningState;
  /** Additional information on the state */
  stateMessage: Maybe<Scalars['String']['output']>;
};

export enum SigningState {
  /** state where the identification failed */
  IdentFailed = 'ident_failed',
  /** state where user need to identify himself, you should display the ident_url */
  IdentNeeded = 'ident_needed',
  /** state where the identification is done and the user is waiting for verification, you must display a waiting panel */
  IdentProcessing = 'ident_processing',
  /** Signing failed */
  SignFailed = 'sign_failed',
  /** state where the user need to sign the documents, you should display the sign_url */
  SignNeeded = 'sign_needed',
  /** state where the user signed the documents and is waiting for verification */
  SignProcessing = 'sign_processing',
  /** Signing rejected by signer */
  SignRejected = 'sign_rejected',
  /** Signing success */
  SignSuccess = 'sign_success'
}

export enum SimpleSigningState {
  Aborted = 'aborted',
  Draft = 'draft',
  Signed = 'signed',
  WaitingBasquiat = 'waiting_basquiat',
  WaitingClient = 'waiting_client',
  WaitingHandwritten = 'waiting_handwritten',
  WaitingWorker = 'waiting_worker'
}

/** Reset signing process result */
export type SkribbleResetSigningProcessResult = {
  success: Scalars['Boolean']['output'];
};

/** Pass information to create skribble document signature request */
export type SkribbleSampleSignatureInput = {
  /** The url of the pdf to sign */
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  /** Quality of the signature request */
  quality?: InputMaybe<SignatureQuality>;
  /** The title of the signature request */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** The result of the signing process of a contract, this is liked to the user that call, it will change depending if you are a client or a worker */
export type SkribbleSigninProcess = {
  /** True if the email has been sent from Skribble */
  emailSent: Maybe<Scalars['Boolean']['output']>;
  /** Quality of the signature request */
  quality: SignatureQuality;
  /** Skribble status of the signature request */
  signState: SkribbleSigningState;
  /** Sign url if using AES, SES will not have a direct sign url, it will be sent by email */
  signUrl: Maybe<Scalars['String']['output']>;
  /** The id of the asset that will contained the signed document, you must check for this status change to know if the sign is ready */
  signedAssetId: Maybe<Scalars['ID']['output']>;
};

export enum SkribbleSigningState {
  /** Signature was declined */
  Declined = 'DECLINED',
  /** Waiting for singature */
  Open = 'OPEN',
  /** Document has been signed */
  Signed = 'SIGNED',
  /** Signature process has been aborted */
  Withdrawn = 'WITHDRAWN'
}

export type SummaryRow = {
  category: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  detailedDescription: Maybe<Scalars['String']['output']>;
  productKey: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  repetition: Maybe<RepetitionType>;
  unitPrice: Scalars['Int']['output'];
};

export enum TerminateReason {
  BusyOnProposedDates = 'busy_on_proposed_dates',
  CompanyCulture = 'company_culture',
  Distance = 'distance',
  InadequateWorkingConditions = 'inadequate_working_conditions',
  InsufficientCompensation = 'insufficient_compensation',
  LackOfProfessionalAdvancement = 'lack_of_professional_advancement',
  LiftSeriousReason = 'lift_serious_reason',
  NotSignedInTime = 'not_signed_in_time',
  Other = 'other',
  OverqualifiedLabor = 'overqualified_labor',
  RelationalProblem = 'relational_problem',
  RequiredCompensation = 'required_compensation',
  SalaryTooHigh = 'salary_too_high',
  SigningRejected = 'signing_rejected',
  SkillsTasksMismatch = 'skills_tasks_mismatch',
  SolvencyProblem = 'solvency_problem',
  UnderQualifiedLabor = 'under_qualified_labor',
  UnjustifiedAbsences = 'unjustified_absences',
  WeatherConditionSuitability = 'weather_condition_suitability',
  WorkerProfileMismatch = 'worker_profile_mismatch'
}

export enum TerminatedByType {
  Client = 'client',
  System = 'system',
  Worker = 'worker'
}

export type TerminationDataInput = {
  otherReason?: InputMaybe<Scalars['String']['input']>;
  reason: TerminateReason;
  terminationDate: Scalars['Date']['input'];
};

export type TerminationInfo = {
  cancellationRequest: Maybe<MissionCancellationRequest>;
  minimalEndDate: Scalars['Date']['output'];
  newState: ContractState;
};

export enum TimeMode {
  Fixed = 'fixed',
  Free = 'free'
}

export type TimeSheet = {
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  acceptedBy: Maybe<TimeSheetAcceptedBy>;
  autoAcceptAt: Maybe<Scalars['DateTime']['output']>;
  comments: Maybe<Array<TimeSheetComment>>;
  contractWeeklyDurationMinutes: Scalars['Int']['output'];
  fromDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isExactTimeSheet: Scalars['Boolean']['output'];
  missionInfo: MissionInfo;
  rejectedAt: Maybe<Scalars['DateTime']['output']>;
  status: TimeSheetState;
  submittedAt: Maybe<Scalars['DateTime']['output']>;
  toDate: Scalars['Date']['output'];
  totalTrackedDurationMinutes: Scalars['Int']['output'];
  trackedDurationBreakdown: TrackedDurationBreakdownType;
  trackingDates: Array<DateScheduleType>;
};

export enum TimeSheetAcceptedBy {
  Automatic = 'automatic',
  Client = 'client'
}

export type TimeSheetComment = {
  author: User;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type TimeSheetPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<TimeSheet>;
  pageInfo: PageInfo;
};

export enum TimeSheetState {
  Accepted = 'accepted',
  Open = 'open',
  Rejected = 'rejected',
  Submitted = 'submitted'
}

export type TrackedDurationBreakdownItemType = {
  hourRate: Scalars['Int']['output'];
  totalDurationMinutes: Scalars['Int']['output'];
  type: WorkingTimeDurationBreakdownItemType;
};

export type TrackedDurationBreakdownType = {
  items: Array<TrackedDurationBreakdownItemType>;
};

export enum Unit {
  Days = 'days',
  Hours = 'hours'
}

export type UpdateAmendmentInput = {
  applyDate?: InputMaybe<Scalars['Date']['input']>;
  /** The whole new deduction list: an existing deduction keeps its id */
  deductions?: InputMaybe<Array<MissionDeductionInput>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** The whole new fee list: an existing fee keeps its id */
  fees?: InputMaybe<Array<MissionFeeInput>>;
  grossSalary?: InputMaybe<Scalars['Int']['input']>;
  /** Makes the change temporary; left out, the amendment keeps its until date, null clears it */
  untilDate?: InputMaybe<Scalars['Date']['input']>;
  vacationDays?: InputMaybe<Scalars['Int']['input']>;
  workingTimeClassicSpec?: InputMaybe<WorkingTimeClassicInput>;
};

export type User = {
  address: Maybe<Address>;
  age: Maybe<Scalars['Int']['output']>;
  androidIntercomHmac: Maybe<Scalars['String']['output']>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  birthdate: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use clientInfos instead */
  clientInfo: Maybe<ClientInfo>;
  clientInfos: Maybe<Array<ClientInfo>>;
  clientProfiles: Maybe<Array<ClientProfile>>;
  email: Maybe<Scalars['String']['output']>;
  expoPushToken: Maybe<Scalars['String']['output']>;
  firebasePushToken: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Gender>;
  id: Scalars['ID']['output'];
  impersonatedBy: Maybe<UserInfo>;
  intercomUserId: Maybe<Scalars['String']['output']>;
  iosIntercomHmac: Maybe<Scalars['String']['output']>;
  isImpersonate: Maybe<Scalars['Boolean']['output']>;
  kycStatus: Maybe<IdentificationStatus>;
  lang: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  nationality: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  verified: Maybe<Scalars['Boolean']['output']>;
  webIntercomHmac: Maybe<Scalars['String']['output']>;
  /** @deprecated Use workerProfile.lastWorkPermit instead */
  workPermit: Maybe<WorkingPermit>;
  workerInfo: Maybe<WorkerInfo>;
  workerProfile: Maybe<WorkerProfile>;
};

export type UserInfo = {
  avatarUrl: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type UserInput = {
  address?: InputMaybe<AddressInput>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not editable anymore */
  birthdate?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  firebasePushToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not editable anymore */
  gender?: InputMaybe<Gender>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not editable anymore */
  nationality?: InputMaybe<Scalars['String']['input']>;
};

/** The result of starting a verification process with Veriff */
export type VeriffStartVerificationResult = {
  /** Session URL to use in the SDK */
  sessionUrl: Scalars['String']['output'];
};

export type WithholdingTaxCodeOverride = {
  code: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  validFrom: Scalars['Date']['output'];
  validTo: Maybe<Scalars['Date']['output']>;
};

export type WorkPermit = {
  type: Maybe<WorkingPermitType>;
  validFrom: Maybe<Scalars['DateTime']['output']>;
  validTo: Maybe<Scalars['DateTime']['output']>;
};

export type WorkerExperience = {
  educationLevel: EducationLevel;
  professionName: Scalars['String']['output'];
  trainingName: Scalars['String']['output'];
  yearsOfExperience: Scalars['Int']['output'];
};

export type WorkerExperienceInput = {
  educationLevel: EducationLevel;
  professionName: Scalars['String']['input'];
  trainingName: Scalars['String']['input'];
  yearsOfExperience: Scalars['Decimal']['input'];
};

export type WorkerGroup = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkerInfo = {
  address: Maybe<Address>;
  avatarUrl: Maybe<Scalars['String']['output']>;
  avsNumber: Maybe<Scalars['String']['output']>;
  birthdate: Maybe<Scalars['Date']['output']>;
  curriculumVitae: Maybe<CurriculumVitae>;
  deleted: Scalars['Boolean']['output'];
  documents: Maybe<Array<Document>>;
  /** @deprecated Use experiences.education_level field instead */
  educationLevel: Maybe<EducationLevel>;
  email: Maybe<Scalars['String']['output']>;
  experiences: Maybe<Array<WorkerExperience>>;
  gender: Maybe<Gender>;
  hasExperience: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kycStatus: Maybe<KycStatus>;
  lang: Scalars['String']['output'];
  missionCount: Maybe<MissionCount>;
  /** @deprecated Returns empty array, Query mission for user instead, this avoid security problems */
  missions: Maybe<Array<MissionInfo>>;
  name: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  workPermitStatus: WorkingPermitStatus;
  /** @deprecated Use experiences.years_of_experience field instead */
  yearsOfExperience: Maybe<Scalars['Int']['output']>;
};

export type WorkerInfoInput = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Gender>;
};

export type WorkerInfoPageResult = {
  count: Scalars['Int']['output'];
  elements: Array<WorkerInfo>;
  pageInfo: PageInfo;
};

export type WorkerProfile = {
  avsNumber: Maybe<Scalars['String']['output']>;
  bankAccount: Maybe<BankAccount>;
  children: Maybe<Array<Person>>;
  churchMember: Maybe<Scalars['Boolean']['output']>;
  contractAcceptedAt: Maybe<Scalars['String']['output']>;
  contractEffectiveAsset: Maybe<Asset>;
  contractSealedAt: Maybe<Scalars['DateTime']['output']>;
  contractSignedAt: Maybe<Scalars['DateTime']['output']>;
  curriculumVitae: Maybe<CurriculumVitae>;
  documents: Maybe<Array<Document>>;
  /** @deprecated Use experiences.education_level field instead */
  educationLevel: Maybe<EducationLevel>;
  /** @deprecated Use curriculumVitae field instead */
  experiences: Maybe<Array<WorkerExperience>>;
  hasChildren: Maybe<Scalars['Boolean']['output']>;
  /** Is set to true, experiences field will have at less 1 element */
  hasExperience: Maybe<Scalars['Boolean']['output']>;
  hasFiscalAttestation: Maybe<Scalars['Boolean']['output']>;
  hasOtherActivity: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastWorkPermit: Maybe<WorkPermit>;
  lppRegistrations: Array<LppRegistration>;
  maritalStatus: Maybe<MaritalStatus>;
  maritalStatusFrom: Maybe<Scalars['Date']['output']>;
  otherActivityPercent: Maybe<Scalars['Float']['output']>;
  partner: Maybe<Person>;
  relationshipCount: Scalars['Int']['output'];
  swissOrHasPermitAnswer: Maybe<Scalars['Boolean']['output']>;
  weeklyResidenceCanton: Maybe<Scalars['String']['output']>;
  /** Withholding-tax tariff codes a tax office imposed, oldest first. Set by Lift only. */
  withholdingTaxCodeOverrides: Array<WithholdingTaxCodeOverride>;
  /** @deprecated Use last_work_permit instead */
  workPermit: Maybe<WorkingPermit>;
  /** @deprecated Use experiences.years_of_experience field instead */
  yearsOfExperience: Maybe<Scalars['Int']['output']>;
};

export type WorkerProfileInput = {
  avsNumber?: InputMaybe<Scalars['String']['input']>;
  bankAccount?: InputMaybe<BankAccountInput>;
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  children?: InputMaybe<Array<PersonInput>>;
  churchMember?: InputMaybe<Scalars['Boolean']['input']>;
  curriculumVitae?: InputMaybe<CurriculumVitaeInput>;
  documents?: InputMaybe<Array<DocumentInput>>;
  educationLevel?: InputMaybe<EducationLevel>;
  experiences?: InputMaybe<Array<WorkerExperienceInput>>;
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  hasFiscalAttestation?: InputMaybe<Scalars['Boolean']['input']>;
  hasOtherActivity?: InputMaybe<Scalars['Boolean']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatus>;
  maritalStatusFrom?: InputMaybe<Scalars['Date']['input']>;
  otherActivityPercent?: InputMaybe<Scalars['Float']['input']>;
  partner?: InputMaybe<PersonInput>;
  swissOrHasPermitAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<UserInput>;
  weeklyResidenceCanton?: InputMaybe<Scalars['String']['input']>;
  yearsOfExperience?: InputMaybe<Scalars['Int']['input']>;
};

export enum WorkingPermit {
  InProcess = 'in_process',
  NoPermit = 'no_permit',
  PermitB = 'permit_b',
  PermitC = 'permit_c',
  PermitCi = 'permit_ci',
  PermitF = 'permit_f',
  PermitG = 'permit_g',
  PermitL = 'permit_l',
  PermitN = 'permit_n',
  PermitOther = 'permit_other',
  PermitS = 'permit_s'
}

export enum WorkingPermitStatus {
  InProcess = 'in_process',
  NoNeed = 'no_need',
  None = 'none',
  Valid = 'valid'
}

export enum WorkingPermitType {
  PermitB = 'permit_b',
  PermitC = 'permit_c',
  PermitCi = 'permit_ci',
  PermitF = 'permit_f',
  PermitG = 'permit_g',
  PermitL = 'permit_l',
  PermitN = 'permit_n',
  PermitOther = 'permit_other',
  PermitS = 'permit_s'
}

export enum WorkingTime {
  Classic = 'classic',
  Schedule = 'schedule',
  Specific = 'specific'
}

export type WorkingTimeClassicInput = {
  dailyHours?: InputMaybe<Scalars['Float']['input']>;
  repetition: Repetition;
  unit: Unit;
  unitCount?: InputMaybe<Scalars['Float']['input']>;
};

export type WorkingTimeClassicType = {
  dailyHours: Maybe<Scalars['Float']['output']>;
  repetition: Repetition;
  unit: Unit;
  unitCount: Maybe<Scalars['Float']['output']>;
};

export enum WorkingTimeDurationBreakdownItemType {
  Accident = 'accident',
  Day = 'day',
  DeathCloseRelative = 'death_close_relative',
  ExtraWork = 'extra_work',
  Marriage = 'marriage',
  Maternity = 'maternity',
  Military = 'military',
  Moving = 'moving',
  Night = 'night',
  NightExtraWork = 'night_extra_work',
  Other = 'other',
  Overtime = 'overtime',
  PublicHoliday = 'public_holiday',
  Sickness = 'sickness',
  SicknessCloseRelative = 'sickness_close_relative',
  Sunday = 'sunday',
  Trainee = 'trainee',
  Vacation = 'vacation',
  WorkPublicHoliday = 'work_public_holiday'
}

export type WorkingTimeScheduleInput = {
  fri?: InputMaybe<DayScheduleInput>;
  mon?: InputMaybe<DayScheduleInput>;
  sat?: InputMaybe<DayScheduleInput>;
  sun?: InputMaybe<DayScheduleInput>;
  thu?: InputMaybe<DayScheduleInput>;
  tue?: InputMaybe<DayScheduleInput>;
  wed?: InputMaybe<DayScheduleInput>;
};

export type WorkingTimeScheduleType = {
  fri: Maybe<DayScheduleType>;
  mon: Maybe<DayScheduleType>;
  sat: Maybe<DayScheduleType>;
  sun: Maybe<DayScheduleType>;
  thu: Maybe<DayScheduleType>;
  tue: Maybe<DayScheduleType>;
  wed: Maybe<DayScheduleType>;
};

export type WorkingTimeSpecificInput = {
  dates: Array<DateScheduleInput>;
};

export type WorkingTimeSpecificType = {
  dates: Array<DateScheduleType>;
};
